{
  "de": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "Your message",
          "from_address": "Your email",
          "to_address": "Recipient’s email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "Agent Location",
          "services": "Specialties",
          "supported_languages": "Supported Languages"
        },
        "enquiry": {
          "body": "Please write your message",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "Where do you live?",
          "email": "Email",
          "name": "Name",
          "phone": "Phone",
          "prefecture": "Where are you searching for properties?",
          "verification_code": "",
          "verification_code2": "Verification code"
        },
        "property": {
          "beds": "Zimmer",
          "price": "Price",
          "property_location": "Prefecture",
          "property_type": "Property Type"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokio",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "prefectures": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokio",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "services": {
            "1": "For Sale",
            "16": "Judicial Scrivener",
            "2": "For Rent",
            "4": "Property Management",
            "8": "Renovation"
          }
        },
        "property": {
          "available_from": {
            "1": "Now",
            "2": "Ask",
            "3": "Specified Date"
          },
          "available_from_period": {
            "1": "Beginning",
            "2": "Middle",
            "3": "End"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "Urbanization promotion areas",
            "2": "Urbanization control areas",
            "3": "Non-classified city planning areas",
            "4": "Non-city planning areas"
          },
          "connecting_road_direction1": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction2": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction3": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction4": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_kind1": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind2": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind3": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind4": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "construction_status": {
            "2": "Under Construction",
            "3": "New Construction"
          },
          "guarantee_company": {
            "1": "Required to use",
            "2": "Not Required",
            "3": "Usable"
          },
          "insurance": {
            "1": "Necessary",
            "2": "Unnecessary"
          },
          "land_category": {
            "1": "residential areas",
            "2": "rice fields",
            "3": "crop fields",
            "4": "mountains and forests",
            "5": "hybrid areas",
            "6": "others"
          },
          "land_law_notification": {
            "1": "Notification required",
            "2": "No notification required",
            "3": "Notification in progress"
          },
          "land_rights": {
            "1": "Ownership",
            "2": "Leasehold",
            "3": "Leasehold",
            "4": "Leasehold",
            "5": "Leasehold"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "Non specified",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokio",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "main_aspect": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "management": {
            "1": "Self Management",
            "2": "Partial Consignment",
            "3": "Full Consignment"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "Available",
            "2": "No Vacancy",
            "3": "None"
          },
          "prefecture": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokio",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "property_type": {
            "-1": "Alle Immobilien",
            "1": "Wohnung",
            "10": "Gewerbeimmobilie",
            "11": "Hotel / Ryokan",
            "12": "Reihenhaus",
            "2": "Haus",
            "3": "Grundstück",
            "4": "Kurzzeitmiete",
            "5": "Wohngemeinschaft",
            "6": "Mehrfamilienhaus",
            "7": "Bürofläche",
            "8": "Einzelhandelsfläche",
            "9": "Office and Retail Space"
          },
          "purpose": {
            "1": "For Residence",
            "2": "For Investment"
          },
          "status": {
            "1": "Vacant",
            "2": "Occupied",
            "3": "Uncompleted",
            "4": "Vacant Lot",
            "5": "Old House",
            "6": "Rented"
          },
          "structure": {
            "1": "Wooden",
            "10": "ALC",
            "11": "RCB",
            "12": "CFT",
            "13": "Wooden・Other",
            "14": "RC・Other",
            "15": "SRC・Other",
            "16": "S・Other",
            "17": "Block・Other",
            "18": "PC・Other",
            "19": "HPC・Other",
            "2": "RC",
            "20": "LGS・Other",
            "21": "ALC・Other",
            "22": "RCB・Other",
            "23": "CFT・Other",
            "3": "SRC",
            "4": "S",
            "5": "Block",
            "6": "PC",
            "7": "HPC",
            "8": "Other",
            "9": "LGS"
          },
          "type": {
            "rent": "Rent",
            "sale": "Buy"
          },
          "type_of_transaction": {
            "1": "Property Owner",
            "2": "Seller Direct",
            "3": "Exclusive Right-to-Sell Listing Agreement",
            "4": "Exclusive Agency Listing Agreement",
            "5": "Open Listing Agreement",
            "6": "Brokerage",
            "7": "Other"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "Sorry, we were unable to find any agents matching your search criteria.<br>Please try searching agents with different criteria."
        }
      }
    },
    "bookmark_properties": {
      "index": {
        "js": {
          "empty": "You haven't saved any property yet"
        }
      }
    },
    "c": {
      "bookmarked_properties": "Favorites",
      "buy": "Kaufen",
      "city_ward": "City / Ward",
      "featured": "Featured",
      "for_rent": {
        "other": "Mieten"
      },
      "for_sale": {
        "other": "Kaufen"
      },
      "japan_blog": "Japan Property Blog",
      "login": "Log In",
      "logout": "Logout",
      "make_enquiry": "Make Inquiry",
      "max_price": "Max. Preis (JPY)",
      "name": "Name",
      "no_max_price": "No max price",
      "no_max_price_short": "No max",
      "no_min_price_short": "No min",
      "phone": "Phone",
      "please_write_your_message": "Please write your message*",
      "property_agencies_and_sellers": "Real Estate Agents & Companies in %{location}",
      "provided_by": "Listing provided by",
      "read_more": "Read More",
      "rent": "Mieten",
      "sale": "Sale",
      "search": "Search",
      "search_by": {
        "fewer_filters": "Close",
        "more_filters": "Other Search",
        "prefecture": "Prefecture",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "Immobilientyp",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "Search for Properties",
      "sign_up": "Sign Up",
      "type_of_home": "Type of Home"
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "By pressing Contact agent, you agree that Japan-Property and real estate professionals may contact you via phone/text about your inquiry, which may involve the use of automated means. You don't need to consent as a condition of buying any property or services. Message/data rates may apply. You also agree to our <a href='/terms'>Terms</a> of Use, and to our <a href='/privacy-policy'>Privacy Policy</a> regarding the information relating to you. We may share information about your recent and future site activity with your agent to help them understand what you're looking for in a home.",
          "contact_agent": "Contact agent"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "Please select cities",
          "select_prefecture": "Select Prefecture",
          "title": "Search for Property by City"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "Sorry, we were unable to find any properties matching your search criteria.<br>Please try searching properties with different criteria.",
          "features": "Features",
          "furnished": "Furnished",
          "luxury": "Luxury",
          "no_agency_fee": "No Agency Fee",
          "no_deposit": "No Deposit",
          "no_guarantor": "No Guarantor",
          "no_key_money": "No Key Money",
          "over_selected": "You can inquire about up to 5 properties at a time. Please complete your inquiry.",
          "relevant_listings": "Relevant listings",
          "sort": "Sort: ",
          "sort_by_gross_yield_higher": "Gross Yield (High to Low)",
          "sort_by_home_age_higher": "Home Age (Newest)",
          "sort_by_home_size_higher": "Home Size (Largest)",
          "sort_by_land_size_higher": "Land Size (Largest)",
          "sort_by_price_higher": "Price (High to Low)",
          "sort_by_price_lower": "Price (Low to High)",
          "sort_by_purpose": "For Investment"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "Check out this home I found on Japan-Property.",
            "send_email": "Send email",
            "sent": "Successfully shared this property"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "Please select stations",
          "please_select_train_lines": "Please select train lines",
          "select_prefecture": "Select Prefecture",
          "select_stations": "Select Stations",
          "title": "Search for Property by Train Station"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "Delete Account",
          "favorite": "Favorite",
          "myaccount": "My Account"
        },
        "language": "Sprache"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "catch_copy": "Haus oder Wohnung <br class='u-sp'>in Japan kaufen",
          "caution_search_box": "Hinweis: Die Ergebnisse werden auf Englisch angezeigt."
        }
      }
    }
  },
  "en": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "Your message",
          "from_address": "Your email",
          "to_address": "Recipient’s email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "Agent Location",
          "services": "Specialties",
          "supported_languages": "Supported Languages"
        },
        "enquiry": {
          "body": "Please write your message",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "Where do you live?",
          "email": "Email",
          "name": "Name",
          "phone": "Phone",
          "prefecture": "Where are you searching for properties?",
          "verification_code": "",
          "verification_code2": "Verification code"
        },
        "property": {
          "beds": "Beds",
          "price": "Price",
          "property_location": "Prefecture",
          "property_type": "Property Type"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "prefectures": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "services": {
            "1": "For Sale",
            "16": "Judicial Scrivener",
            "2": "For Rent",
            "4": "Property Management",
            "8": "Renovation"
          }
        },
        "property": {
          "available_from": {
            "1": "Now",
            "2": "Ask",
            "3": "Specified Date"
          },
          "available_from_period": {
            "1": "Early ",
            "2": "Mid-",
            "3": "Late "
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "Urbanization promotion areas",
            "2": "Urbanization control areas",
            "3": "Non-classified city planning areas",
            "4": "Non-city planning areas"
          },
          "connecting_road_direction1": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction2": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction3": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction4": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_kind1": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind2": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind3": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind4": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "construction_status": {
            "2": "Under Construction",
            "3": "New Construction"
          },
          "guarantee_company": {
            "1": "Required to use",
            "2": "Not Required",
            "3": "Usable"
          },
          "insurance": {
            "1": "Necessary",
            "2": "Unnecessary"
          },
          "land_category": {
            "1": "residential areas",
            "2": "rice fields",
            "3": "crop fields",
            "4": "mountains and forests",
            "5": "hybrid areas",
            "6": "others"
          },
          "land_law_notification": {
            "1": "Notification required",
            "2": "No notification required",
            "3": "Notification in progress"
          },
          "land_rights": {
            "1": "Freehold",
            "2": "Leasehold",
            "3": "Leasehold",
            "4": "Leasehold",
            "5": "Leasehold"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "Non specified",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "main_aspect": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "management": {
            "1": "Self Management",
            "2": "Partial Consignment",
            "3": "Full Consignment"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "Available",
            "2": "None",
            "3": "None"
          },
          "prefecture": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "property_type": {
            "-1": "All Property Types",
            "1": "Apartment",
            "10": "Commercial Building",
            "11": "Hotel / Ryokan",
            "12": "Town House",
            "2": "House",
            "3": "Land",
            "4": "Short Term",
            "5": "Share House",
            "6": "Apartment Building",
            "7": "Office Space",
            "8": "Retail Space",
            "9": "Office and Retail Space"
          },
          "purpose": {
            "1": "For Residence",
            "2": "For Investment"
          },
          "status": {
            "1": "Vacant",
            "10": "In use",
            "2": "Occupied",
            "3": "Under construction",
            "4": "Vacant land",
            "5": "Old house exists",
            "6": "Tenanted",
            "7": "Partially tenanted",
            "8": "Fully tenanted",
            "9": "Never occupied"
          },
          "structure": {
            "1": "Wooden Structure",
            "10": "Autoclaved Lightweight Concrete",
            "11": "Reinforced Concrete Block",
            "12": "Concrete Filled Steel Tube",
            "13": "Wooden Structure・Other",
            "14": "Reinforced Concrete・Other",
            "15": "Steel Reinforced Concrete・Other",
            "16": "Steel Frame Structure・Other",
            "17": "Concrete Block Structure・Other",
            "18": "Precast Concrete・Other",
            "19": "H-Shaped Steel Precast Concrete・Other",
            "2": "Reinforced Concrete",
            "20": "Light Gauge Steel・Other",
            "21": "Autoclaved Lightweight Concrete・Other",
            "22": "Reinforced Concrete Block・Other",
            "23": "Concrete Filled Steel Tube・Other",
            "3": "Steel Reinforced Concrete",
            "4": "Steel Frame Structure",
            "5": "Concrete Block Structure",
            "6": "Precast Concrete",
            "7": "H-Shaped Steel Precast Concrete",
            "8": "Other",
            "9": "Light Gauge Steel"
          },
          "type": {
            "rent": "Rent",
            "sale": "Buy"
          },
          "type_of_transaction": {
            "1": "Property Owner",
            "2": "Seller Direct",
            "3": "Exclusive Right-to-Sell Listing Agreement",
            "4": "Exclusive Agency Listing Agreement",
            "5": "Open Listing Agreement",
            "6": "Brokerage",
            "7": "Other"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "Sorry, we were unable to find any agents matching your search criteria.<br>Please try searching agents with different criteria."
        }
      }
    },
    "bookmark_properties": {
      "index": {
        "js": {
          "empty": "You haven't saved any property yet"
        }
      }
    },
    "c": {
      "bookmarked_properties": "Favorites",
      "buy": "Buy",
      "city_ward": "City / Ward",
      "featured": "Featured",
      "for_rent": {
        "other": "For Rent"
      },
      "for_sale": {
        "other": "For Sale"
      },
      "japan_blog": "Japan Property Blog",
      "login": "Log In",
      "logout": "Logout",
      "make_enquiry": "Make Inquiry",
      "max_price": "Max Price (JPY)",
      "name": "Name",
      "no_max_price": "No max price",
      "no_max_price_short": "No max",
      "no_min_price_short": "No min",
      "phone": "Phone",
      "please_write_your_message": "Please write your message*",
      "property_agencies_and_sellers": "Real Estate Agents & Companies in %{location}",
      "provided_by": "Listing provided by",
      "read_more": "Read More",
      "rent": "Rent",
      "sale": "Sale",
      "search": "Search",
      "search_box": {
        "home_type": "Home Type",
        "maximum": "Maximum",
        "minimum": "Minimum",
        "price_range": "Price Range"
      },
      "search_by": {
        "fewer_filters": "Close",
        "more_filters": "Other Search",
        "prefecture": "Prefecture",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "Property Type",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "Search for Properties",
      "sign_up": "Sign Up",
      "type_of_home": "Type of Home",
      "yen": "JPY"
    },
    "devise": {
      "registrations": {
        "confirm_destroy": {
          "js": {
            "confirmation": "Are you sure you want to permanently delete Account ?"
          }
        }
      }
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "By pressing Contact agent, you agree that Japan-Property and real estate professionals may contact you via phone/text about your inquiry, which may involve the use of automated means. You don't need to consent as a condition of buying any property or services. Message/data rates may apply. You also agree to our <a href='/terms'>Terms</a> of Use, and to our <a href='/privacy-policy'>Privacy Policy</a> regarding the information relating to you. We may share information about your recent and future site activity with your agent to help them understand what you're looking for in a home.",
          "contact_agent": "Contact agent",
          "submit": "Contact agent"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "Please select cities",
          "select_prefecture": "Select Prefecture",
          "title": "Search for Property by City"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "Sorry, we were unable to find any properties matching your search criteria.<br>Please try searching properties with different criteria.",
          "features": "Features",
          "over_selected": "You can inquire about up to 5 properties at a time. Please complete your inquiry.",
          "relevant_listings": "Relevant listings",
          "sort": "Sort: ",
          "sort_by_gross_yield_higher": "Gross Yield (High to Low)",
          "sort_by_home_age_higher": "Home Age (Newest)",
          "sort_by_home_size_higher": "Home Size (Largest)",
          "sort_by_land_size_higher": "Land Size (Largest)",
          "sort_by_price_higher": "Price (High to Low)",
          "sort_by_price_lower": "Price (Low to High)",
          "sort_by_purpose": "For Investment"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "Check out this home I found on Japan-Property.",
            "send_email": "Send email",
            "sent": "Successfully shared this property"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "Please select stations",
          "please_select_train_lines": "Please select train lines",
          "select_prefecture": "Select Prefecture",
          "select_stations": "Select Stations",
          "title": "Search for Property by Train Station"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "Delete Account",
          "favorite": "Favorite",
          "myaccount": "My Account"
        },
        "language": "Language"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "Area Guides",
          "buying_guide": "Buying Guide",
          "catch_copy": "Find your ideal home <br class='u-sp'>in Japan",
          "explore_top_neighborhoods": "Explore Top Neighborhoods",
          "featured_agencies_and_sellers": "Featured Agencies and Sellers",
          "featured_properties_for_rent": "Featured Properties for Rent",
          "featured_properties_for_sale": "Featured Properties for Sale",
          "find_more_agents": "Find More Agents",
          "footer_description": "Japan-property.jp has one of the leading property portal websites in Japan, foreign buyers and investors to find property from the country's top real estate agents and property developers. The site’s search tools empower customers to easily 'move online' becoming the one stop shop to buy, sell or rent real estate.<br>We will fully support you in purchasing real estate made for investment, as well as securing rental properties such as houses or apartments at popular locations in Japan such as Tokyo, Yokohama, Osaka and Kyoto.",
          "loan_guide": "Loan Guide",
          "newest_listings_for_rent": "Newest Listings for Rent",
          "newest_listings_for_sale": "Newest Listings for Sale",
          "renting_guide": "Renting Guide",
          "view_more_properties": "View More Properties"
        }
      }
    }
  },
  "fr": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "Your message",
          "from_address": "Your email",
          "to_address": "Recipient’s email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "Agent Location",
          "services": "Specialties",
          "supported_languages": "Supported Languages"
        },
        "enquiry": {
          "body": "Please write your message",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "Where do you live?",
          "email": "Email",
          "name": "Name",
          "phone": "Phone",
          "prefecture": "Where are you searching for properties?",
          "verification_code": "",
          "verification_code2": "Verification code"
        },
        "property": {
          "beds": "Chambres",
          "price": "Price",
          "property_location": "Prefecture",
          "property_type": "Property Type"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "prefectures": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "services": {
            "1": "For Sale",
            "16": "Judicial Scrivener",
            "2": "For Rent",
            "4": "Property Management",
            "8": "Renovation"
          }
        },
        "property": {
          "available_from": {
            "1": "Now",
            "2": "Ask",
            "3": "Specified Date"
          },
          "available_from_period": {
            "1": "Beginning",
            "2": "Middle",
            "3": "End"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "Urbanization promotion areas",
            "2": "Urbanization control areas",
            "3": "Non-classified city planning areas",
            "4": "Non-city planning areas"
          },
          "connecting_road_direction1": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction2": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction3": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction4": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_kind1": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind2": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind3": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind4": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "construction_status": {
            "2": "Under Construction",
            "3": "New Construction"
          },
          "guarantee_company": {
            "1": "Required to use",
            "2": "Not Required",
            "3": "Usable"
          },
          "insurance": {
            "1": "Necessary",
            "2": "Unnecessary"
          },
          "land_category": {
            "1": "residential areas",
            "2": "rice fields",
            "3": "crop fields",
            "4": "mountains and forests",
            "5": "hybrid areas",
            "6": "others"
          },
          "land_law_notification": {
            "1": "Notification required",
            "2": "No notification required",
            "3": "Notification in progress"
          },
          "land_rights": {
            "1": "Ownership",
            "2": "Leasehold",
            "3": "Leasehold",
            "4": "Leasehold",
            "5": "Leasehold"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "Non specified",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "main_aspect": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "management": {
            "1": "Self Management",
            "2": "Partial Consignment",
            "3": "Full Consignment"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "Available",
            "2": "No Vacancy",
            "3": "None"
          },
          "prefecture": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "property_type": {
            "-1": "Tous les biens",
            "1": "Appartement",
            "10": "Immeuble commercial",
            "11": "Hôtel / Ryokan",
            "12": "Maison de ville",
            "2": "Maison",
            "3": "Terrain",
            "4": "Location de courte durée",
            "5": "Colocation",
            "6": "Immeuble résidentiel",
            "7": "Espace de bureau",
            "8": "Espace commercial",
            "9": "Office and Retail Space"
          },
          "purpose": {
            "1": "For Residence",
            "2": "For Investment"
          },
          "status": {
            "1": "Vacant",
            "2": "Occupied",
            "3": "Uncompleted",
            "4": "Vacant Lot",
            "5": "Old House",
            "6": "Rented"
          },
          "structure": {
            "1": "Wooden",
            "10": "ALC",
            "11": "RCB",
            "12": "CFT",
            "13": "Wooden・Other",
            "14": "RC・Other",
            "15": "SRC・Other",
            "16": "S・Other",
            "17": "Block・Other",
            "18": "PC・Other",
            "19": "HPC・Other",
            "2": "RC",
            "20": "LGS・Other",
            "21": "ALC・Other",
            "22": "RCB・Other",
            "23": "CFT・Other",
            "3": "SRC",
            "4": "S",
            "5": "Block",
            "6": "PC",
            "7": "HPC",
            "8": "Other",
            "9": "LGS"
          },
          "type": {
            "rent": "Rent",
            "sale": "Buy"
          },
          "type_of_transaction": {
            "1": "Property Owner",
            "2": "Seller Direct",
            "3": "Exclusive Right-to-Sell Listing Agreement",
            "4": "Exclusive Agency Listing Agreement",
            "5": "Open Listing Agreement",
            "6": "Brokerage",
            "7": "Other"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "Sorry, we were unable to find any agents matching your search criteria.<br>Please try searching agents with different criteria."
        }
      }
    },
    "bookmark_properties": {
      "index": {
        "js": {
          "empty": "You haven't saved any property yet"
        }
      }
    },
    "c": {
      "bookmarked_properties": "Favorites",
      "buy": "Acheter",
      "city_ward": "City / Ward",
      "featured": "Featured",
      "for_rent": {
        "other": "à louer"
      },
      "for_sale": {
        "other": "à vendre"
      },
      "japan_blog": "Japan Property Blog",
      "login": "Log In",
      "logout": "Logout",
      "make_enquiry": "Make Inquiry",
      "max_price": "Prix max. (JPY)",
      "name": "Name",
      "no_max_price": "No max price",
      "no_max_price_short": "No max",
      "no_min_price_short": "No min",
      "phone": "Phone",
      "please_write_your_message": "Please write your message*",
      "property_agencies_and_sellers": "Real Estate Agents & Companies in %{location}",
      "provided_by": "Listing provided by",
      "read_more": "Read More",
      "rent": "Louer",
      "sale": "Sale",
      "search": "Search",
      "search_by": {
        "fewer_filters": "Close",
        "more_filters": "Other Search",
        "prefecture": "Prefecture",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "Types de bien",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "Search for Properties",
      "sign_up": "Sign Up",
      "type_of_home": "Type of Home"
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "By pressing Contact agent, you agree that Japan-Property and real estate professionals may contact you via phone/text about your inquiry, which may involve the use of automated means. You don't need to consent as a condition of buying any property or services. Message/data rates may apply. You also agree to our <a href='/terms'>Terms</a> of Use, and to our <a href='/privacy-policy'>Privacy Policy</a> regarding the information relating to you. We may share information about your recent and future site activity with your agent to help them understand what you're looking for in a home.",
          "contact_agent": "Contact agent"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "Please select cities",
          "select_prefecture": "Select Prefecture",
          "title": "Search for Property by City"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "Sorry, we were unable to find any properties matching your search criteria.<br>Please try searching properties with different criteria.",
          "features": "Features",
          "furnished": "Furnished",
          "luxury": "Luxury",
          "no_agency_fee": "No Agency Fee",
          "no_deposit": "No Deposit",
          "no_guarantor": "No Guarantor",
          "no_key_money": "No Key Money",
          "over_selected": "You can inquire about up to 5 properties at a time. Please complete your inquiry.",
          "relevant_listings": "Relevant listings",
          "sort": "Sort: ",
          "sort_by_gross_yield_higher": "Gross Yield (High to Low)",
          "sort_by_home_age_higher": "Home Age (Newest)",
          "sort_by_home_size_higher": "Home Size (Largest)",
          "sort_by_land_size_higher": "Land Size (Largest)",
          "sort_by_price_higher": "Price (High to Low)",
          "sort_by_price_lower": "Price (Low to High)",
          "sort_by_purpose": "For Investment"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "Check out this home I found on Japan-Property.",
            "send_email": "Send email",
            "sent": "Successfully shared this property"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "Please select stations",
          "please_select_train_lines": "Please select train lines",
          "select_prefecture": "Select Prefecture",
          "select_stations": "Select Stations",
          "title": "Search for Property by Train Station"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "Delete Account",
          "favorite": "Favorite",
          "myaccount": "My Account"
        },
        "language": "Langue"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "catch_copy": "Acheter une maison ou un appartement au Japon",
          "caution_search_box": "Attention : les résultats de recherche s’affichent en anglais."
        }
      }
    }
  },
  "ja": {
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "services": "提供サービス"
        },
        "enquiry": {
          "body": "お問い合わせ内容",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "ご住所",
          "email": "Email",
          "name": "お名前",
          "phone": "電話番号"
        },
        "property": {
          "beds": "間取り",
          "price": "価格",
          "property_location": "都道府県",
          "property_type": "物件タイプ"
        }
      },
      "enums": {
        "agent_profile": {
          "edit_languages": {
            "1": "English",
            "1024": "Bahasa Indonesia(インドネシア語)",
            "128": "Português(ポルトガル語)",
            "16": "한국어(韓国語)",
            "2": "简体中文",
            "2048": "日本語",
            "256": "Русский(ロシア語)",
            "32": "Français(フランス語)",
            "4": "繁體中文",
            "4096": "Deutsch(ドイツ語)",
            "512": "Tiếng Việt(ベトナム語)",
            "64": "Español(スペイン語)",
            "8": "ไทย(タイ語)",
            "8192": "Italiano(イタリア語)"
          },
          "languages": {
            "1": "English",
            "1024": "Bahasa Indonesia",
            "128": "Português",
            "16": "한국어",
            "2": "简体中文",
            "2048": "日本語",
            "256": "Русский",
            "32": "Français",
            "4": "繁體中文",
            "4096": "Deutsch",
            "512": "Tiếng Việt",
            "64": "Español",
            "8": "ไทย",
            "8192": "Italiano"
          },
          "locations": {
            "-1": "全国（ALL Area)",
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "prefectures": {
            "-1": "全国（ALL Area)",
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "rent_listing_count": {
            "0": "未掲載",
            "100": "100件掲載",
            "1000": "1000件掲載",
            "1000000000": "無制限",
            "200": "200件掲載",
            "2000": "2000件掲載",
            "25": "25件掲載",
            "300": "300件掲載",
            "3000": "3000件掲載",
            "400": "400件掲載",
            "5": "5件掲載",
            "50": "50件掲載",
            "500": "500件掲載",
            "600": "600件掲載",
            "700": "700件掲載",
            "800": "800件掲載",
            "900": "900件掲載"
          },
          "rent_listing_plan": {
            "1": "掲載課金プラン",
            "2": "成約報酬プラン",
            "3": "お問い合わせ課金プラン"
          },
          "sale_listing_count": {
            "0": "未掲載",
            "100": "100件掲載",
            "1000": "1000件掲載",
            "1000000000": "無制限",
            "200": "200件掲載",
            "2000": "2000件掲載",
            "25": "25件掲載",
            "300": "300件掲載",
            "3000": "3000件掲載",
            "400": "400件掲載",
            "5": "5件掲載",
            "50": "50件掲載",
            "500": "500件掲載",
            "600": "600件掲載",
            "700": "700件掲載",
            "800": "800件掲載",
            "900": "900件掲載"
          },
          "sale_listing_plan": {
            "1": "掲載課金プラン",
            "2": "成約報酬プラン",
            "3": "お問い合わせ課金プラン"
          },
          "services": {
            "1": "売買(For Sale)",
            "16": "司法書士(Judicial Scrivener)",
            "2": "賃貸(For Rent)",
            "4": "不動産管理(Property Management)",
            "8": "リフォーム・リノベーション(Renovation)"
          },
          "sign_up_content": {
            "1": "5件掲載プラン　6ヵ月間無料トライアルキャンペーン",
            "2": "通常掲載申し込み",
            "3": "Japan-Property への物件広告掲載 お申し込み",
            "4": "Japan-Property への企業情報掲載(無料) お申し込み"
          }
        },
        "property": {
          "agent_fee_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "available_from": {
            "1": "即時",
            "2": "相談",
            "3": "期日指定"
          },
          "available_from_period": {
            "1": "上旬",
            "2": "中旬",
            "3": "下旬"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "市街化区域",
            "2": "市街化調整区域",
            "3": "区域区分が定められていない都市計画区域",
            "4": "都市計画区域外"
          },
          "connecting_road_direction1": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction2": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction3": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_direction4": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "connecting_road_kind1": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind2": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind3": {
            "1": "公道",
            "2": "私道"
          },
          "connecting_road_kind4": {
            "1": "公道",
            "2": "私道"
          },
          "construction_status": {
            "1": "中古",
            "2": "建築中",
            "3": "新築"
          },
          "deposit_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "features": {
            "building_facilities": [
              "auto_lock",
              "security_camera",
              "delivery_box",
              "elevator",
              "trunk_room",
              "bicycle_parking",
              "motorcycle_parking",
              "laundromat",
              "always_garbage_disposal_allowed",
              "private_security_company",
              "party_room",
              "kids_room",
              "theater_room"
            ],
            "highlights": [
              "top_floor",
              "high_floor",
              "corner_unit",
              "penthouse",
              "multiple_bathrooms",
              "oceanfront",
              "ocean_view",
              "lake_view",
              "city_skyline_view",
              "mount_fuji_view",
              "resort_property",
              "beach_resort_homes",
              "ski_resort_homes",
              "onsen_resort_homes",
              "highland_resort_homes",
              "lake_resort_homes",
              "near_narita_airport",
              "near_haneda_airport",
              "near_kansai_airport",
              "near_new_chitose",
              "near_fukuoka_airport",
              "traditional_japanese_homes",
              "short_term_rental_allowed",
              "full_occupancy",
              "residents_lounge",
              "cafe_lounge",
              "co_working_space",
              "guest_room",
              "swimming_pool",
              "fitness",
              "sauna",
              "hot_spring",
              "concierge_service",
              "solar_power_generation",
              "ev_charging_station",
              "attached_garage",
              "new_seismic_code",
              "seismic_isolation_structure",
              "no_deposit",
              "no_key_money",
              "furniture_and_appliances_included",
              "monthly_stay_available",
              "luxury",
              "office_use_allowed"
            ],
            "internet_tv": [
              "broadband",
              "catv",
              "free_internet_usage",
              "free_catc_usage"
            ],
            "kitchen_appliances": [
              "refrigerator",
              "stove",
              "systemized_kitchen",
              "all_electric",
              "dishwasher",
              "waste_disposal_unit"
            ],
            "legal_restrictions": [
              "architectural_condition_attached",
              "not_rebuildable"
            ],
            "outdoor_features": [
              "balcony",
              "private_garden"
            ],
            "payment_terms": [
              "credit_card_payment_allowed_on_monthly_rent",
              "credit_card_payment_allowed_on_upfront_costs",
              "credit_card_payment_allowed"
            ],
            "property_type_structure": [
              "duplex_apartment",
              "housing_performance_evaluation_report"
            ],
            "room_features": [
              "video_intercom",
              "flooring",
              "air_conditioner",
              "cooling",
              "heating",
              "underfloor_heating",
              "separate_toilet_and_bath",
              "shower",
              "separate_wash_basin",
              "bidet_toilet",
              "bath_reheating_functionality",
              "auto_bath",
              "bathroom_tv",
              "bathroom_dehumidifier",
              "hot_water_supply",
              "loft",
              "lighting_equipment_included",
              "fire_alarm"
            ],
            "storage": [
              "clost",
              "walk_in_closet",
              "shoes_closet",
              "living_room_storage",
              "storage_room"
            ],
            "terms_conditions": [
              "room_sharing_allowed",
              "two_tenants_allowed",
              "male_only",
              "female_only",
              "singles_only",
              "senior_friendly",
              "pets_negotiable",
              "musical_instruments_allowed"
            ]
          },
          "features_only_rent": [
            "no_deposit",
            "no_key_money",
            "furniture_and_appliances_included",
            "monthly_stay_available",
            "luxury",
            "office_use_allowed",
            "private_security_company",
            "free_internet_usage",
            "free_catc_usage",
            "room_sharing_allowed",
            "two_tenants_allowed",
            "male_only",
            "female_only",
            "singles_only",
            "senior_friendly",
            "musical_instruments_allowed",
            "credit_card_payment_allowed_on_monthly_rent",
            "credit_card_payment_allowed_on_upfront_costs",
            "credit_card_payment_allowed"
          ],
          "features_only_sale": [
            "short_term_rental_allowed",
            "full_occupancy",
            "housing_performance_evaluation_report",
            "architectural_condition_attached",
            "not_rebuildable"
          ],
          "guarantee_company": {
            "1": "利用必須",
            "2": "不要",
            "3": "利用可"
          },
          "insurance": {
            "1": "要",
            "2": "不要"
          },
          "key_money_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "land_category": {
            "1": "宅地",
            "10": "山林・その他",
            "11": "雑種地・その他",
            "2": "田",
            "3": "畑",
            "4": "山林",
            "5": "雑種地",
            "6": "その他",
            "7": "宅地・その他",
            "8": "田・その他",
            "9": "畑・その他"
          },
          "land_law_notification": {
            "1": "要",
            "2": "不要",
            "3": "届出中"
          },
          "land_rights": {
            "1": "所有権",
            "2": "借地権",
            "3": "賃借権",
            "4": "転借権",
            "5": "地上権"
          },
          "land_use_zone": {
            "1": "第一種低層住居専用",
            "10": "準工業",
            "11": "工業",
            "12": "工業専用",
            "13": "無指定",
            "14": "田園住居",
            "2": "第二種低層住居専用",
            "3": "第一種中高層住居専用",
            "4": "第二種中高層住居専用",
            "5": "第一種住居",
            "6": "第二種住居",
            "7": "準住居",
            "8": "近隣商業",
            "9": "商業"
          },
          "main_aspect": {
            "1": "北",
            "2": "北東",
            "3": "東",
            "4": "南東",
            "5": "南",
            "6": "南西",
            "7": "西",
            "8": "北西"
          },
          "management": {
            "1": "自主管理",
            "2": "一部委託",
            "3": "全部委託"
          },
          "management_method": {
            "1": "常駐",
            "2": "日勤",
            "3": "巡回",
            "4": "無"
          },
          "other_expense_code_1": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_2": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_3": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_4": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "other_expense_code_5": {
            "1": "鍵交換費用",
            "10": "その他費用",
            "2": "クリーニング費用",
            "3": "消毒・抗菌・消臭費",
            "5": "保証会社利用料",
            "6": "火災保険料",
            "7": "入居者サポート費",
            "8": "エアコンクリーニング",
            "9": "害虫駆除費"
          },
          "parking_space_type": {
            "1": "空有",
            "2": "空無",
            "3": "無"
          },
          "prefecture": {
            "1": "北海道",
            "10": "群馬県",
            "11": "埼玉県",
            "12": "千葉県",
            "13": "東京都",
            "14": "神奈川県",
            "15": "新潟県",
            "16": "富山県",
            "17": "石川県",
            "18": "福井県",
            "19": "山梨県",
            "2": "青森県",
            "20": "長野県",
            "21": "岐阜県",
            "22": "静岡県",
            "23": "愛知県",
            "24": "三重県",
            "25": "滋賀県",
            "26": "京都府",
            "27": "大阪府",
            "28": "兵庫県",
            "29": "奈良県",
            "3": "岩手県",
            "30": "和歌山県",
            "31": "鳥取県",
            "32": "島根県",
            "33": "岡山県",
            "34": "広島県",
            "35": "山口県",
            "36": "徳島県",
            "37": "香川県",
            "38": "愛媛県",
            "39": "高知県",
            "4": "宮城県",
            "40": "福岡県",
            "41": "佐賀県",
            "42": "長崎県",
            "43": "熊本県",
            "44": "大分県",
            "45": "宮崎県",
            "46": "鹿児島県",
            "47": "沖縄県",
            "5": "秋田県",
            "6": "山形県",
            "7": "福島県",
            "8": "茨城県",
            "9": "栃木県"
          },
          "property_type": {
            "-1": "すべての物件種別",
            "1": "アパート・マンション",
            "10": "一棟商業ビル",
            "11": "ホテル・旅館",
            "12": "タウンハウス",
            "2": "戸建て",
            "3": "土地",
            "4": "短期滞在",
            "5": "ゲストハウス・シェアハウス",
            "6": "一棟マンション・アパート",
            "7": "事務所",
            "8": "店舗",
            "9": "事務所・店舗"
          },
          "purpose": {
            "purpose_investment": "投資用",
            "purpose_residence": "自住用"
          },
          "renewal_fee_type": {
            "1": "ヶ月",
            "2": "円"
          },
          "rooms": {
            "1": 1,
            "101": "個室",
            "102": "相部屋",
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "rooms_layout": {
            "1": "R",
            "2": "K",
            "3": "SK",
            "4": "DK",
            "5": "SDK",
            "6": "LK",
            "7": "SLK",
            "8": "LDK",
            "9": "SLDK"
          },
          "rooms_layout_search": {
            "1-1": "1R",
            "1-2": "1K",
            "2-2": "2K",
            "2-4": "2DK",
            "2-8": "2LDK",
            "3-2": "3K",
            "3-4": "3DK",
            "3-8": "3LDK",
            "4-2": "4K",
            "4-4": "4DK",
            "4-8": "4LDK",
            "5": "4LDK以上"
          },
          "rooms_rent": {
            "101": "個室",
            "102": "相部屋"
          },
          "rooms_sale": {
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "rooms_shared": {
            "1": 1,
            "2": 2,
            "3": 3,
            "4": 4,
            "5": 5,
            "6": "6+"
          },
          "setback": {
            "1": "有"
          },
          "status": {
            "1": "空室",
            "10": "使用中",
            "2": "居住中",
            "3": "未完成",
            "4": "更地",
            "5": "古屋あり",
            "6": "賃貸中",
            "7": "賃貸中(一部)",
            "8": "賃貸中(全部)",
            "9": "未入居"
          },
          "structure": {
            "1": "木造",
            "10": "ALC",
            "11": "鉄筋ブロック",
            "12": "CFT",
            "13": "木造・その他",
            "14": "RC・その他",
            "15": "SRC・その他",
            "16": "鉄骨造・その他",
            "17": "ブロック・その他",
            "18": "PC・その他",
            "19": "HPC・その他",
            "2": "RC",
            "20": "軽量鉄骨・その他",
            "21": "ALC・その他",
            "22": "鉄筋ブロック・その他",
            "23": "CFT・その他",
            "3": "SRC",
            "4": "鉄骨造",
            "5": "ブロック",
            "6": "PC",
            "7": "HPC",
            "8": "その他",
            "9": "軽量鉄骨"
          },
          "terms_of_lease_type": {
            "1": "期限表示",
            "2": "期間表示"
          },
          "type": {
            "Properties::Rent": "賃貸",
            "Properties::Sale": "売買"
          },
          "type_of_transaction": {
            "1": "売主/貸主",
            "2": "代理",
            "3": "専属専任媒介",
            "4": "専任媒介",
            "5": "一般媒介",
            "6": "仲介",
            "7": "その他"
          }
        }
      }
    },
    "c": {
      "bookmarked_properties": "お気に入り登録物件",
      "buy": "買う",
      "city_ward": "市区町村",
      "featured": "おすすめ物件表示",
      "for_rent": "賃貸物件",
      "for_sale": "売買物件",
      "japan_blog": "ブログ",
      "login": "ログイン",
      "logout": "ログアウト",
      "make_enquiry": "この物件に問い合わせ",
      "max_price": "上限予算",
      "name": "お名前",
      "no_max_price": "上限なし",
      "no_max_price_short": "上限なし",
      "no_min_price_short": "下限なし",
      "phone": "電話番号",
      "please_write_your_message": "お問い合わせ内容",
      "provided_by": "Listing provided by :<br>%{name}",
      "read_more": "Read More",
      "rent": "借りる",
      "sale": "売り",
      "search": "検索",
      "search_box": {
        "home_type": "物件種別",
        "maximum": "上限",
        "minimum": "下限",
        "price_range": "価格帯"
      },
      "search_by": {
        "fewer_filters": "閉じる",
        "more_filters": "その他検索",
        "please_select_city": "市区郡にチェックをいれてください",
        "please_select_stations": "駅にチェックをいれてください",
        "please_select_train_lines": "沿線にチェックをいれてください",
        "prefecture": "都道府県",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "物件タイプ",
        "search_by_city": "エリアから探す",
        "search_by_train_station": "沿線・駅から探す",
        "search_for_homes_by_city": "Serch for homes by city",
        "search_for_property_by_city": "エリアから探す",
        "search_for_property_by_trainline": "沿線・駅から探す",
        "select_stations": "駅を絞り込む"
      },
      "search_for_properties": "物件検索",
      "sign_up": "会員登録",
      "type_of_home": "物件種別",
      "yen": "円"
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "送信ボタンを押すことで、お客様は、お問い合わせ内容について弊社から電話やSMS等で連絡を受けることに同意したものとみなされます。これらの連絡には、自動送信システムが使用される場合があります。<br>あわせて、当サイトの「<a href='/terms'>利用規約</a>」および、お客様の情報の取り扱いに関する「<a href='/privacy-policy'>プライバシーポリシー</a>」に同意いただくものとします。",
          "contact_agent": "Contact agent",
          "submit": "送信"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "市区町村を選択してください",
          "select_prefecture": "都道府県を選択",
          "title": "エリアから探す"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "指定された条件に合致する物件が見つかりませんでした。",
          "features": "こだわり条件",
          "over_selected": "一度にまとめてお問い合わせできるのは最大5物件までです。お問い合わせ内容をご確認のうえ、送信してください。",
          "relevant_listings": "おすすめ順",
          "sort": "並び替え：",
          "sort_by_gross_yield_higher": "利回りの大きい順",
          "sort_by_home_age_higher": "完成年月の新しい順",
          "sort_by_home_size_higher": "専有面積の大きい順",
          "sort_by_land_size_higher": "土地面積の大きい順",
          "sort_by_price_higher": "価格の高い順",
          "sort_by_price_lower": "価格の安い順",
          "sort_by_purpose": "投資用"
        }
      },
      "map": {
        "js": {
          "cities": "Cities",
          "empty": "指定された条件に合致する物件が見つかりませんでした。",
          "features": "こだわり条件",
          "over_selected": "一度にまとめてお問い合わせできるのは最大5物件までです。お問い合わせ内容をご確認のうえ、送信してください。",
          "relevant_listings": "おすすめ順",
          "sort": "並び替え：",
          "sort_by_gross_yield_higher": "利回りの大きい順",
          "sort_by_home_age_higher": "完成年月の新しい順",
          "sort_by_home_size_higher": "専有面積の大きい順",
          "sort_by_land_size_higher": "土地面積の大きい順",
          "sort_by_price_higher": "価格の高い順",
          "sort_by_price_lower": "価格の安い順",
          "sort_by_purpose": "投資用"
        }
      },
      "train": {
        "js": {
          "please_select_stations": "駅を選択してください",
          "please_select_train_lines": "沿線を選択してください",
          "select_prefecture": "都道府県を選択",
          "select_stations": "駅を選択",
          "title": "沿線・駅から探す"
        }
      }
    },
    "shared": {
      "header": {
        "language": "Language"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "Area Guides",
          "buying_guide": "Buying Guide",
          "catch_copy": "Find your ideal home <br class='u-sp'>in Japan",
          "explore_top_neighborhoods": "Explore Top Neighborhoods",
          "featured_agencies_and_sellers": "Featured Agencies and Sellers",
          "featured_properties_for_rent": "Featured Properties for Rent",
          "featured_properties_for_sale": "Featured Properties for Sale",
          "find_more_agents": "Find More Agents",
          "footer_description": "Japan-property.jp has one of the leading property portal websites in Japan, foreign buyers and investors to find property from the country's top real estate agents and property developers. The site’s search tools empower customers to easily 'move online' becoming the one stop shop to buy, sell or rent real estate.<br>We will fully support you in purchasing real estate made for investment, as well as securing rental properties such as houses or apartments at popular locations in Japan such as Tokyo, Yokohama, Osaka and Kyoto.",
          "loan_guide": "Loan Guide",
          "newest_listings_for_rent": "新着賃貸物件",
          "newest_listings_for_sale": "新着売買物件",
          "renting_guide": "Renting Guide",
          "view_more_properties": "物件一覧を見る"
        }
      }
    }
  },
  "nl": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "Your message",
          "from_address": "Your email",
          "to_address": "Recipient’s email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "Agent Location",
          "services": "Specialties",
          "supported_languages": "Supported Languages"
        },
        "enquiry": {
          "body": "Please write your message",
          "body_default": {
            "rent": "Hello,\n\nI would like to schedule a viewing of this Property for Rent.  Please can you call or email me as soon as possible.\n\nBest Regards.\n",
            "sale": "Hello,\n\nI would like to schedule a viewing of this Property for Sale.  Please can you call or email me as soon as possible.\n\nBest Regards.\n"
          },
          "country_of_residence": "Where do you live?",
          "email": "Email",
          "name": "Name",
          "phone": "Phone",
          "prefecture": "Where are you searching for properties?",
          "verification_code": "",
          "verification_code2": "Verification code"
        },
        "property": {
          "beds": "Slaapkamers",
          "price": "Price",
          "property_location": "Prefecture",
          "property_type": "Property Type"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "prefectures": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "services": {
            "1": "For Sale",
            "16": "Judicial Scrivener",
            "2": "For Rent",
            "4": "Property Management",
            "8": "Renovation"
          }
        },
        "property": {
          "available_from": {
            "1": "Now",
            "2": "Ask",
            "3": "Specified Date"
          },
          "available_from_period": {
            "1": "Beginning",
            "2": "Middle",
            "3": "End"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "STUDIO",
            "1": "1 Bed",
            "101": "Private Room",
            "102": "Shared Room",
            "2": "2 Beds",
            "201": "Whole Building",
            "3": "3 Beds",
            "4": "4 Beds",
            "5": "5 Beds",
            "6": "6+ Beds"
          },
          "city_planning": {
            "1": "Urbanization promotion areas",
            "2": "Urbanization control areas",
            "3": "Non-classified city planning areas",
            "4": "Non-city planning areas"
          },
          "connecting_road_direction1": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction2": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction3": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_direction4": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "connecting_road_kind1": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind2": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind3": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "connecting_road_kind4": {
            "1": "Public roads",
            "2": "Private roads"
          },
          "construction_status": {
            "2": "Under Construction",
            "3": "New Construction"
          },
          "guarantee_company": {
            "1": "Required to use",
            "2": "Not Required",
            "3": "Usable"
          },
          "insurance": {
            "1": "Necessary",
            "2": "Unnecessary"
          },
          "land_category": {
            "1": "residential areas",
            "2": "rice fields",
            "3": "crop fields",
            "4": "mountains and forests",
            "5": "hybrid areas",
            "6": "others"
          },
          "land_law_notification": {
            "1": "Notification required",
            "2": "No notification required",
            "3": "Notification in progress"
          },
          "land_rights": {
            "1": "Ownership",
            "2": "Leasehold",
            "3": "Leasehold",
            "4": "Leasehold",
            "5": "Leasehold"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "Non specified",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Yokohama/Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Kanazawa/Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Nagoya/Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Kobe/Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Sendai/Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi",
            "99": "All over Japan"
          },
          "main_aspect": {
            "1": "North",
            "2": "Northeast",
            "3": "East",
            "4": "Southeast",
            "5": "South",
            "6": "Southwest",
            "7": "West",
            "8": "Northwest"
          },
          "management": {
            "1": "Self Management",
            "2": "Partial Consignment",
            "3": "Full Consignment"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "Available",
            "2": "No Vacancy",
            "3": "None"
          },
          "prefecture": {
            "-1": "All over Japan",
            "1": "Hokkaido",
            "10": "Gunma",
            "11": "Saitama",
            "12": "Chiba",
            "13": "Tokyo",
            "14": "Kanagawa",
            "15": "Niigata",
            "16": "Toyama",
            "17": "Ishikawa",
            "18": "Fukui",
            "19": "Yamanashi",
            "2": "Aomori",
            "20": "Nagano",
            "21": "Gifu",
            "22": "Shizuoka",
            "23": "Aichi",
            "24": "Mie",
            "25": "Shiga",
            "26": "Kyoto",
            "27": "Osaka",
            "28": "Hyogo",
            "29": "Nara",
            "3": "Iwate",
            "30": "Wakayama",
            "31": "Tottori",
            "32": "Shimane",
            "33": "Okayama",
            "34": "Hiroshima",
            "35": "Yamaguchi",
            "36": "Tokushima",
            "37": "Kagawa",
            "38": "Ehime",
            "39": "Kochi",
            "4": "Miyagi",
            "40": "Fukuoka",
            "41": "Saga",
            "42": "Nagasaki",
            "43": "Kumamoto",
            "44": "Oita",
            "45": "Miyazaki",
            "46": "Kagoshima",
            "47": "Okinawa",
            "5": "Akita",
            "6": "Yamagata",
            "7": "Fukushima",
            "8": "Ibaraki",
            "9": "Tochigi"
          },
          "property_type": {
            "-1": "Alle woningtypes",
            "1": "Appartement",
            "10": "Commercieel vastgoed",
            "11": "Hotel / Ryokan",
            "12": "Rijtjeshuis",
            "2": "Huis",
            "3": "Grond",
            "4": "Korte termijn huur",
            "5": "Kamer",
            "6": "Appartementengebouw",
            "7": "Kantoorruimte",
            "8": "Retail Space",
            "9": "Winkelruimte"
          },
          "purpose": {
            "1": "For Residence",
            "2": "For Investment"
          },
          "status": {
            "1": "Vacant",
            "2": "Occupied",
            "3": "Uncompleted",
            "4": "Vacant Lot",
            "5": "Old House",
            "6": "Rented"
          },
          "structure": {
            "1": "Wooden",
            "10": "ALC",
            "11": "RCB",
            "12": "CFT",
            "13": "Wooden・Other",
            "14": "RC・Other",
            "15": "SRC・Other",
            "16": "S・Other",
            "17": "Block・Other",
            "18": "PC・Other",
            "19": "HPC・Other",
            "2": "RC",
            "20": "LGS・Other",
            "21": "ALC・Other",
            "22": "RCB・Other",
            "23": "CFT・Other",
            "3": "SRC",
            "4": "S",
            "5": "Block",
            "6": "PC",
            "7": "HPC",
            "8": "Other",
            "9": "LGS"
          },
          "type": {
            "rent": "Rent",
            "sale": "Buy"
          },
          "type_of_transaction": {
            "1": "Property Owner",
            "2": "Seller Direct",
            "3": "Exclusive Right-to-Sell Listing Agreement",
            "4": "Exclusive Agency Listing Agreement",
            "5": "Open Listing Agreement",
            "6": "Brokerage",
            "7": "Other"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "Sorry, we were unable to find any agents matching your search criteria.<br>Please try searching agents with different criteria."
        }
      }
    },
    "bookmark_properties": {
      "index": {
        "js": {
          "empty": "You haven't saved any property yet"
        }
      }
    },
    "c": {
      "bookmarked_properties": "Favorites",
      "buy": "Kopen",
      "city_ward": "City / Ward",
      "featured": "Featured",
      "for_rent": {
        "other": "te huur"
      },
      "for_sale": {
        "other": "te koop"
      },
      "japan_blog": "Japan Property Blog",
      "login": "Log In",
      "logout": "Logout",
      "make_enquiry": "Make Inquiry",
      "max_price": "Max. Prijs (JPY)",
      "name": "Name",
      "no_max_price": "No max price",
      "no_max_price_short": "No max",
      "no_min_price_short": "No min",
      "phone": "Phone",
      "please_write_your_message": "Please write your message*",
      "property_agencies_and_sellers": "Real Estate Agents & Companies in %{location}",
      "provided_by": "Listing provided by",
      "read_more": "Read More",
      "rent": "Huren",
      "sale": "Sale",
      "search": "Search",
      "search_by": {
        "fewer_filters": "Close",
        "more_filters": "Other Search",
        "prefecture": "Prefecture",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "Woningtype",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "Search for Properties",
      "sign_up": "Sign Up",
      "type_of_home": "Type of Home"
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "By pressing Contact agent, you agree that Japan-Property and real estate professionals may contact you via phone/text about your inquiry, which may involve the use of automated means. You don't need to consent as a condition of buying any property or services. Message/data rates may apply. You also agree to our <a href='/terms'>Terms</a> of Use, and to our <a href='/privacy-policy'>Privacy Policy</a> regarding the information relating to you. We may share information about your recent and future site activity with your agent to help them understand what you're looking for in a home.",
          "contact_agent": "Contact agent"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "Please select cities",
          "select_prefecture": "Select Prefecture",
          "title": "Search for Property by City"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "Sorry, we were unable to find any properties matching your search criteria.<br>Please try searching properties with different criteria.",
          "features": "Features",
          "furnished": "Furnished",
          "luxury": "Luxury",
          "no_agency_fee": "No Agency Fee",
          "no_deposit": "No Deposit",
          "no_guarantor": "No Guarantor",
          "no_key_money": "No Key Money",
          "over_selected": "You can inquire about up to 5 properties at a time. Please complete your inquiry.",
          "relevant_listings": "Relevant listings",
          "sort": "Sort: ",
          "sort_by_gross_yield_higher": "Gross Yield (High to Low)",
          "sort_by_home_age_higher": "Home Age (Newest)",
          "sort_by_home_size_higher": "Home Size (Largest)",
          "sort_by_land_size_higher": "Land Size (Largest)",
          "sort_by_price_higher": "Price (High to Low)",
          "sort_by_price_lower": "Price (Low to High)",
          "sort_by_purpose": "For Investment"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "Check out this home I found on Japan-Property.",
            "send_email": "Send email",
            "sent": "Successfully shared this property"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "Please select stations",
          "please_select_train_lines": "Please select train lines",
          "select_prefecture": "Select Prefecture",
          "select_stations": "Select Stations",
          "title": "Search for Property by Train Station"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "Delete Account",
          "favorite": "Favorite",
          "myaccount": "My Account"
        },
        "language": "Taal"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "catch_copy": "Huis of appartement <br class='u-sp'>in Japan kopen",
          "caution_search_box": "Let op: de zoekresultaten worden in het Engels weergegeven."
        }
      }
    }
  },
  "th": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "ข้อความของคุณ",
          "from_address": "เมลของคุณ",
          "to_address": "เมลของผู้รับ"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "ตัวแทนสถานที่ตั้ง",
          "services": "ความเชี่ยวชาญ",
          "supported_languages": "ภาษาที่ให้บริการ"
        },
        "enquiry": {
          "body": "กรุณาเขียนข้อความของคุณ",
          "body_default": {
            "rent": "สวัสดีค่ะ\n\nดิฉันจะจัดตารางเวลาให้มีการดูที่พักแห่งนี้สำหรับการเช่าคุณสามารถโทรติดต่อ หรือส่งอีเมลมาแจ้งฉันโดยเร็วเท่าที่จะเป็นไปได้\n\nขอแสดงความนับถือ\n",
            "sale": "สวัสดีค่ะ\n\nดิฉันจะจัดตารางเวลาให้มีการดูที่พักแห่งนี้สำหรับการขายคุณสามารถโทรติดต่อ หรือส่งอีเมลมาแจ้งฉันโดยเร็วเท่าที่จะเป็นไปได้\n\nขอแสดงความนับถือ\n"
          },
          "country_of_residence": "คุณอาศัยที่ไหน？",
          "email": "อีเมล",
          "name": "ชื่อ",
          "phone": "เบอร์โทรศัพท์",
          "prefecture": "คุณกำลังค้นหาบ้านที่ไหน？",
          "verification_code": "รหัสยืนยัน"
        },
        "property": {
          "beds": "จำนวนห้องนอนสูงสุด",
          "price": "ราคา",
          "property_location": "เลือกจังหวัด",
          "property_type": "ที่อยู่อาศัย"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "ฮอกไกโด",
            "10": "กุนมะ",
            "11": "ไซตะมะ",
            "12": "จิบะ",
            "13": "โตเกียว",
            "14": "โยะโกะฮะมะ / คะนะงะวะ",
            "15": "นิอิงะตะ",
            "16": "โทะยะมะ",
            "17": "คะนะซะวะ / อิชิกะวะ",
            "18": "ฟุกุอิ",
            "19": "ยะมะนะชิ",
            "2": "อะโอะโมะริ",
            "20": "นะงะโนะ",
            "21": "กิฟุ",
            "22": "ชิซึโอะกะ",
            "23": "นะโงะยะ / ไอชิ",
            "24": "มิเอะ",
            "25": "ชิงะ",
            "26": "เกียวโตะ",
            "27": "โอซะกะ",
            "28": "โกเบ / เฮียวโงะ",
            "29": "นะระ",
            "3": "อิวะเตะ",
            "30": "วะกะยะมะ",
            "31": "ทตโตะริ",
            "32": "ชิมะเนะ",
            "33": "โอะกะยะมะ",
            "34": "ฮิโระชิมะ",
            "35": "ยะมะงุจิ",
            "36": "โทะกุชิมะ",
            "37": "คะงะวะ",
            "38": "เอะฮิเมะ",
            "39": "โคจิ",
            "4": "เซ็นได / มิยะงิ",
            "40": "ฟุกุโอะกะ",
            "41": "ซะงะ",
            "42": "นะงะซะกิ",
            "43": "คุมะโมะโตะ",
            "44": "โออิตะ",
            "45": "มิยะซะกิ",
            "46": "คะโงะชิมะ",
            "47": "โอะกินะวะ",
            "5": "อะกิตะ",
            "6": "ยะมะงะตะ",
            "7": "ฟุกุชิมะ",
            "8": "อิบะระกิ",
            "9": "โทะจิงิ",
            "99": "ทุกจังหวัดใน ประเทศ ญี่ปุ่น"
          },
          "prefectures": {
            "-1": "ทุกจังหวัดใน ประเทศ ญี่ปุ่น",
            "1": "ฮอกไกโด",
            "10": "กุนมะ",
            "11": "ไซตะมะ",
            "12": "จิบะ",
            "13": "โตเกียว",
            "14": "คะนะงะวะ",
            "15": "นิอิงะตะ",
            "16": "โทะยะมะ",
            "17": "อิชิกะวะ",
            "18": "ฟุกุอิ",
            "19": "ยะมะนะชิ",
            "2": "อะโอะโมะริ",
            "20": "นะงะโนะ",
            "21": "กิฟุ",
            "22": "ชิซึโอะกะ",
            "23": "ไอชิ",
            "24": "มิเอะ",
            "25": "ชิงะ",
            "26": "เกียวโตะ",
            "27": "โอซะกะ",
            "28": "เฮียวโงะ",
            "29": "นะระ",
            "3": "อิวะเตะ",
            "30": "วะกะยะมะ",
            "31": "ทตโตะริ",
            "32": "ชิมะเนะ",
            "33": "โอะกะยะมะ",
            "34": "ฮิโระชิมะ",
            "35": "ยะมะงุจิ",
            "36": "โทะกุชิมะ",
            "37": "คะงะวะ",
            "38": "เอะฮิเมะ",
            "39": "โคจิ",
            "4": "มิยะงิ",
            "40": "ฟุกุโอะกะ",
            "41": "ซะงะ",
            "42": "นะงะซะกิ",
            "43": "คุมะโมะโตะ",
            "44": "โออิตะ",
            "45": "มิยะซะกิ",
            "46": "คะโงะชิมะ",
            "47": "โอะกินะวะ",
            "5": "อะกิตะ",
            "6": "ยะมะงะตะ",
            "7": "ฟุกุชิมะ",
            "8": "อิบะระกิ",
            "9": "โทะจิงิ"
          },
          "services": {
            "1": "ขาย",
            "16": "ทนายความจดทะเบียน",
            "2": "ให้เช่า",
            "4": "การจัดการอสังหาริมทรัพย์",
            "8": "ปรับปรุง"
          }
        },
        "property": {
          "available_from": {
            "1": "ทันที",
            "2": "ปรึกษา",
            "3": "วันที่ที่ระบุ"
          },
          "available_from_period": {
            "1": "ต้นเดือน",
            "2": "กลางเดือน",
            "3": "ปลายเดือน"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "สตูดิโอ",
            "1": "1ห้องนอน",
            "101": "ห้องส่วนตัว",
            "102": "ห้องพักที่ใช้ร่วมกัน",
            "2": "2ห้องนอน",
            "201": "ทั้งอาคาร",
            "3": "3ห้องนอน",
            "4": "4ห้องนอน",
            "5": "5ห้องนอน",
            "6": "6ห้องนอน+"
          },
          "city_planning": {
            "1": "เขตพื้นที่ที่กำลังพัฒนาเป็นเมือง",
            "2": "เขตพื้นที่ควบคุมเพื่อปรับปรุงเป็นเมือง",
            "3": "พื้นที่โครงการเมืองที่ไม่ได้แบ่งเขต",
            "4": "นอกเหนือจากเขตพื้นที่โครงการเมือง"
          },
          "connecting_road_direction1": {
            "1": "เหนือ",
            "2": "ตะวันออกเฉียงเหนือ",
            "3": "ตะวันตก",
            "4": "ตะวันออกเฉียงใต้",
            "5": "ใต้",
            "6": "ตะวันตกเฉียงใต้",
            "7": "ตะวันตก",
            "8": "ตะวันตกเฉียงเหนือ"
          },
          "connecting_road_direction2": {
            "1": "เหนือ",
            "2": "ตะวันออกเฉียงเหนือ",
            "3": "ตะวันตก",
            "4": "ตะวันออกเฉียงใต้",
            "5": "ใต้",
            "6": "ตะวันตกเฉียงใต้",
            "7": "ตะวันตก",
            "8": "ตะวันตกเฉียงเหนือ"
          },
          "connecting_road_direction3": {
            "1": "เหนือ",
            "2": "ตะวันออกเฉียงเหนือ",
            "3": "ตะวันตก",
            "4": "ตะวันออกเฉียงใต้",
            "5": "ใต้",
            "6": "ตะวันตกเฉียงใต้",
            "7": "ตะวันตก",
            "8": "ตะวันตกเฉียงเหนือ"
          },
          "connecting_road_direction4": {
            "1": "เหนือ",
            "2": "ตะวันออกเฉียงเหนือ",
            "3": "ตะวันตก",
            "4": "ตะวันออกเฉียงใต้",
            "5": "ใต้",
            "6": "ตะวันตกเฉียงใต้",
            "7": "ตะวันตก",
            "8": "ตะวันตกเฉียงเหนือ"
          },
          "connecting_road_kind1": {
            "1": "ทางหลวง",
            "2": "ถนนส่วนบุคคล"
          },
          "connecting_road_kind2": {
            "1": "ทางหลวง",
            "2": "ถนนส่วนบุคคล"
          },
          "connecting_road_kind3": {
            "1": "ทางหลวง",
            "2": "ถนนส่วนบุคคล"
          },
          "connecting_road_kind4": {
            "1": "ทางหลวง",
            "2": "ถนนส่วนบุคคล"
          },
          "construction_status": {
            "2": "ภายใต้การก่อสร้าง",
            "3": "ใหม่การก่อสร้าง"
          },
          "guarantee_company": {
            "1": "จำเป็นต้องใช้",
            "2": "ไม่ต้องซื้อประกัน",
            "3": "ที่มีจำหน่าย"
          },
          "insurance": {
            "1": "ต้องซื้อประกัน",
            "2": "ไม่ต้องซื้อประกัน"
          },
          "land_category": {
            "1": "ที่อยู่อาศัย",
            "2": "นา",
            "3": "ไร่",
            "4": "ป่าเขา",
            "5": "พื้นที่ผสม",
            "6": "อื่น ๆ"
          },
          "land_law_notification": {
            "1": "ต้องการ",
            "2": "ไม่ต้องการ",
            "3": "กำลังแจ้งเตือน"
          },
          "land_rights": {
            "1": "กรรมสิทธิ์",
            "2": "สิทธิการเช่าที่ดิน",
            "3": "สิทธิการเช่าที่ดิน",
            "4": "สิทธิการเช่าที่ดิน",
            "5": "สิทธิการเช่าที่ดิน"
          },
          "land_use_zone": {
            "1": "Category 1 low-rise exclusive residential districts",
            "10": "Quasi-industrial districts",
            "11": "Industrial districts",
            "12": "Exclusive industrial districts",
            "13": "ไม่ได้ระบุ",
            "14": "Countryside Residential Zone",
            "2": "Category 2 low-rise exclusive residential districts",
            "3": "Category 1 medium-to-high-rise exclusive residential districts",
            "4": "Category 2 medium-to-high-rise exclusive residential districts",
            "5": "Category 1 residential districts",
            "6": "Category 2 residential districts",
            "7": "Quasi-residential districts",
            "8": "Neighborhood commercial districts",
            "9": "Commercial districts"
          },
          "location": {
            "1": "ฮอกไกโด",
            "10": "กุนมะ",
            "11": "ไซตะมะ",
            "12": "จิบะ",
            "13": "โตเกียว",
            "14": "โยะโกะฮะมะ / คะนะงะวะ",
            "15": "นิอิงะตะ",
            "16": "โทะยะมะ",
            "17": "คะนะซะวะ / อิชิกะวะ",
            "18": "ฟุกุอิ",
            "19": "ยะมะนะชิ",
            "2": "อะโอะโมะริ",
            "20": "นะงะโนะ",
            "21": "กิฟุ",
            "22": "ชิซึโอะกะ",
            "23": "นะโงะยะ / ไอชิ",
            "24": "มิเอะ",
            "25": "ชิงะ",
            "26": "เกียวโตะ",
            "27": "โอซะกะ",
            "28": "โกเบ / เฮียวโงะ",
            "29": "นะระ",
            "3": "อิวะเตะ",
            "30": "วะกะยะมะ",
            "31": "ทตโตะริ",
            "32": "ชิมะเนะ",
            "33": "โอะกะยะมะ",
            "34": "ฮิโระชิมะ",
            "35": "ยะมะงุจิ",
            "36": "โทะกุชิมะ",
            "37": "คะงะวะ",
            "38": "เอะฮิเมะ",
            "39": "โคจิ",
            "4": "เซ็นได / มิยะงิ",
            "40": "ฟุกุโอะกะ",
            "41": "ซะงะ",
            "42": "นะงะซะกิ",
            "43": "คุมะโมะโตะ",
            "44": "โออิตะ",
            "45": "มิยะซะกิ",
            "46": "คะโงะชิมะ",
            "47": "โอะกินะวะ",
            "5": "อะกิตะ",
            "6": "ยะมะงะตะ",
            "7": "ฟุกุชิมะ",
            "8": "อิบะระกิ",
            "9": "โทะจิงิ",
            "99": "ทุกจังหวัดใน ประเทศ ญี่ปุ่น"
          },
          "main_aspect": {
            "1": "เหนือ",
            "2": "ตะวันออกเฉียงเหนือ",
            "3": "ตะวันตก",
            "4": "ตะวันออกเฉียงใต้",
            "5": "ใต้",
            "6": "ตะวันตกเฉียงใต้",
            "7": "ตะวันตก",
            "8": "ตะวันตกเฉียงเหนือ"
          },
          "management": {
            "1": "บริหารด้วยตัวเอง",
            "2": "นิติบุคคลบริหารบางส่วน",
            "3": "นิติบุคคลบริหารทั้งหมด"
          },
          "management_method": {
            "1": "Full-time",
            "2": "Daily service",
            "3": "Patrol",
            "4": "None",
            "5": "Part-time"
          },
          "parking_space_type": {
            "1": "มีให้บริการ",
            "2": "ไม่มีตำแหน่งว่าง",
            "3": "ไม่มีอะไรเลย"
          },
          "prefecture": {
            "-1": "ทุกจังหวัดใน ประเทศ ญี่ปุ่น",
            "1": "ฮอกไกโด",
            "10": "กุนมะ",
            "11": "ไซตะมะ",
            "12": "จิบะ",
            "13": "โตเกียว",
            "14": "คะนะงะวะ",
            "15": "นิอิงะตะ",
            "16": "โทะยะมะ",
            "17": "อิชิกะวะ",
            "18": "ฟุกุอิ",
            "19": "ยะมะนะชิ",
            "2": "อะโอะโมะริ",
            "20": "นะงะโนะ",
            "21": "กิฟุ",
            "22": "ชิซึโอะกะ",
            "23": "ไอชิ",
            "24": "มิเอะ",
            "25": "ชิงะ",
            "26": "เกียวโตะ",
            "27": "โอซะกะ",
            "28": "เฮียวโงะ",
            "29": "นะระ",
            "3": "อิวะเตะ",
            "30": "วะกะยะมะ",
            "31": "ทตโตะริ",
            "32": "ชิมะเนะ",
            "33": "โอะกะยะมะ",
            "34": "ฮิโระชิมะ",
            "35": "ยะมะงุจิ",
            "36": "โทะกุชิมะ",
            "37": "คะงะวะ",
            "38": "เอะฮิเมะ",
            "39": "โคจิ",
            "4": "มิยะงิ",
            "40": "ฟุกุโอะกะ",
            "41": "ซะงะ",
            "42": "นะงะซะกิ",
            "43": "คุมะโมะโตะ",
            "44": "โออิตะ",
            "45": "มิยะซะกิ",
            "46": "คะโงะชิมะ",
            "47": "โอะกินะวะ",
            "5": "อะกิตะ",
            "6": "ยะมะงะตะ",
            "7": "ฟุกุชิมะ",
            "8": "อิบะระกิ",
            "9": "โทะจิงิ"
          },
          "property_type": {
            "-1": "ทั้งหมด",
            "1": "อพาร์ทเม้น (คอนโด)",
            "10": "อาคารพาณิชย์",
            "11": "โรงแรมและเรียวกัง",
            "12": "ทาวน์เฮาส์",
            "2": "บ้านเดี่ยว",
            "3": "ที่ดิน",
            "4": "Short Term",
            "5": "เกสท์เฮาส์",
            "6": "อาคารอพาร์ทเม้นท์ (คอนโดฯ)",
            "7": "ออฟฟิศ",
            "8": "พื้นที่ค้าปลีก",
            "9": "Office and Retail Space"
          },
          "purpose": {
            "1": "For Residence",
            "2": "สำหรับการลงทุน"
          },
          "status": {
            "1": "ว่าง",
            "10": "ใช้งานอยู่",
            "2": "มีผู้อยู่อาศัย",
            "3": "อยู่ระหว่างก่อสร้าง",
            "4": "ที่ดินเปล่า",
            "5": "มีสิ่งปลูกสร้างเก่า",
            "6": "มีผู้เช่าอยู่",
            "7": "ให้เช่าบางส่วน",
            "8": "ให้เช่าเต็ม",
            "9": "ไม่เคยมีผู้อยู่อาศัย"
          },
          "structure": {
            "1": "โครงสร้างไม้",
            "10": "Autoclaved Lightweight Concrete",
            "11": "Reinforced Concrete Block",
            "12": "Concrete Filled Steel Tube",
            "13": "โครงสร้างไม้・อื่น ๆ",
            "14": "โครงสร้างคอนกรีตเสริมเหล็ก・อื่น ๆ",
            "15": "โครงสร้างเหล็กเสริมคอนกรีต・อื่น ๆ",
            "16": "โครงสร้างเหล็ก・อื่น ๆ",
            "17": "Concrete Block Structure・อื่น ๆ",
            "18": "Precast Concrete・อื่น ๆ",
            "19": "H-Shaped Steel Precast Concrete・อื่น ๆ",
            "2": "โครงสร้างคอนกรีตเสริมเหล็ก",
            "20": "Light Gauge Steel・อื่น ๆ",
            "21": "Autoclaved Lightweight Concrete・อื่น ๆ",
            "22": "Reinforced Concrete Block・อื่น ๆ",
            "23": "Concrete Filled Steel Tube・อื่น ๆ",
            "3": "โครงสร้างเหล็กเสริมคอนกรีต",
            "4": "โครงสร้างเหล็ก",
            "5": "Concrete Block Structure",
            "6": "Precast Concrete",
            "7": "H-Shaped Steel Precast Concrete",
            "8": "Other",
            "9": "Light Gauge Steel"
          },
          "type": {
            "rent": "เช่า",
            "sale": "ขาย"
          },
          "type_of_transaction": {
            "1": "เจ้าของทรัพย์สิน",
            "2": "ตัวแทน",
            "3": "นายหน้า",
            "4": "นายหน้า",
            "5": "นายหน้า",
            "6": "นายหน้า",
            "7": "อื่น ๆ"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "ขออภัย เราไม่พบอสังหาริมทรัพย์ใดๆที่ตรงกับเงื่อนไขการค้นหาของคุณ<br>ลองค้นหาอสังหาริมทรัพย์ด้วยเงื่อนไขการค้นหาที่แตกต่างออกไป"
        }
      }
    },
    "c": {
      "bookmarked_properties": "รายการประกาศที่บันทึกไว้",
      "buy": "ขาย",
      "city_ward": "เมือง / เขต",
      "featured": "โครงการที่แนะนำ",
      "for_rent": "สำหรับเช่า",
      "for_sale": "สำหรับขาย",
      "japan_blog": "บทความประเทศญี่ปุ่น",
      "login": "เข้าสู่ระบบ",
      "logout": "ออกจากระบบ",
      "make_enquiry": "สอบถามข้อมูล",
      "max_price": "ราคาสูงสุด (JPY)",
      "name": "Name",
      "no_max_price": "ไม่จำกัด",
      "no_max_price_short": "ไม่จำกัด",
      "no_min_price_short": "ไม่จำกัด",
      "phone": "Phone",
      "please_write_your_message": "กรุณาเขียนข้อความของคุณ*",
      "property_agencies_and_sellers": "ตัวแทนอสังหาริมทรัพย์%{location}",
      "provided_by": "รายชื่อให้โดย",
      "read_more": "ดูบทความทั้งหมด",
      "rent": "เช่า",
      "sale": "ขาย",
      "search": "ค้นหา",
      "search_box": {
        "home_type": "Home Type",
        "maximum": "Maximum",
        "minimum": "Minimum",
        "price_range": "Price Range"
      },
      "search_by": {
        "fewer_filters": "Fewer Filters",
        "more_filters": "ค้นหาอื่น ๆ",
        "prefecture": "เลือกจังหวัด",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "ที่อยู่อาศัย",
        "search_by_city": "Search by City",
        "search_by_train_station": "Search by Train Station",
        "search_for_homes_by_city": "Serch for homes by city"
      },
      "search_for_properties": "ค้นหาอสังหาริมทรัพย์",
      "sign_up": "สมัครสมาชิก",
      "type_of_home": "Type of Home",
      "yen": "JPY"
    },
    "devise": {
      "registrations": {
        "confirm_destroy": {
          "js": {
            "confirmation": "แน่ใจหรือว่าต้องการลบบัญชีของคุณอย่างถาวร"
          }
        }
      }
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "การกดติดต่อตัวแทนแสดงว่าคุณยินยอมให้ Japan-Property และผู้เชี่ยวชาญด้านอสังหาริมทรัพย์ติดต่อคุณผ่านโทรศัพท์/ข้อความเกี่ยวกับคำถามของคุณ ซึ่งอาจมีการใช้เทคโนโลยีอัตโนมัติ คุณไม่จำเป็นต้องให้ความยินยอมเป็นเงื่อนไขในการซื้อทรัพย์สิน สินค้าหรือบริการใด ๆ อัตราค่าข้อมูล/ข้อความอาจถูกเรียกเก็บ นอกจากนี้คุณยินยอมให้เราปฏิบัติตาม<a href='/th/terms'>เงื่อนไขการใช้งาน</a>และ<a href='/th/privacy-policy'>นโยบายความเป็นส่วนตัว</a>ของเราเกี่ยวกับข้อมูลที่เกี่ยวข้องกับคุณ เราอาจแบ่งปันข้อมูลเกี่ยวกับการใช้งานของคุณในเว็บไซต์ล่าสุดและในอนาคตกับตัวแทนของคุณเพื่อช่วยให้พวกเขาเข้าใจเรื่องที่คุณกำลังมองหาในบ้าน.",
          "contact_agent": "ติดต่อตัวแทน",
          "submit": "ติดต่อตัวแทน"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "กรุณาเลือกเมือง",
          "select_prefecture": "เลือกจังหวัด",
          "title": "ค้นหาด้วยจังหวัด"
        }
      },
      "index": {
        "js": {
          "cities": "Cities",
          "empty": "ขออภัย เราไม่พบอสังหาริมทรัพย์ใดๆที่ตรงกับเงื่อนไขการค้นหาของคุณ<br>ลองค้นหาอสังหาริมทรัพย์ด้วยเงื่อนไขการค้นหาที่แตกต่างออกไป",
          "features": "จุดเด่น",
          "over_selected": "คุณสามารถสอบถามเกี่ยวกับทรัพย์สินได้สูงสุด 5 รายการในเวลาเดียวกัน โปรดทำการสอบถามของคุณให้เสร็จสิ้น",
          "relevant_listings": "เกี่ยวข้องมากที่สุด",
          "sort": "เรียงตาม: ",
          "sort_by_gross_yield_higher": "ผลตอบแทนการเช่าสูงสุด",
          "sort_by_home_age_higher": "ปีที่สร้าง",
          "sort_by_home_size_higher": "พื้นที่ใช้สอย (ใหญ่-เล็ก)",
          "sort_by_land_size_higher": "ขนาดที่ดิน (ใหญ่-เล็ก)",
          "sort_by_price_higher": "ราคา (สูง-ต่ำ)",
          "sort_by_price_lower": "ราคา (ต่ำ-สูง)",
          "sort_by_purpose": "สำหรับการลงทุน"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "ตรวจสอบบ้านนี้ที่ฉันพบบน Japan-Property",
            "send_email": "ส่งเมล",
            "sent": "แชร์ทรัพย์สินนี้สำเร็จแล้ว"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "กรุณาเลือกสถานี",
          "please_select_train_lines": "กรุณาเลือกสายรถไฟ",
          "select_prefecture": "เลือกจังหวัด",
          "select_stations": "Select Stations",
          "title": "ค้นหาจากสถานีรถไฟฟ้า"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "ลบบัญชี",
          "favorite": "รายการประกาศที่บันทึกไว้",
          "myaccount": "ข้อมูลสมาชิก"
        },
        "language": "เลือกภาษา"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "คูมอพืนที่",
          "buying_guide": "คูมอการซือ",
          "catch_copy": "ค้นหาอสังหาริมทรัพย์ที่ดีที่สุดในญี่ปุ่นเพื่อซื้อหรือเช่า",
          "explore_top_neighborhoods": "สำรวจย่านยอดนิยม",
          "featured_agencies_and_sellers": "แนะนำตัวแทนและผู้ขายอสังหาฯ",
          "featured_properties_for_rent": "แนะนำทรัพย์สินสำหรับให้เช่า",
          "featured_properties_for_sale": "แนะนำทรัพย์สินสำหรับขาย",
          "find_more_agents": "ดูตัวแทนทั้งหมด",
          "footer_description": "Japan-property.jp มีหนึ่งในผู้นำเว็บไซต์พอร์ทัลอสังหาริมทรัพย์ในประเทศญี่ปุ่น <br>\nผู้ซื้อจากต่างประเทศ และนักลงทุนสามารถค้นหาโครงการต่างๆได้จากตัวแทนชั้นนำ และนักพัฒนาอสังหาริมทรัพย์<br>\nเครื่องมือค้นหาจะช่วยทำให้ลูกค้าง่ายต่อการ \" เคลื่อนไหวออนไลน์\" กลายเป็นร้านค้า ซื้อ ขาย หรือให้เช่าแแบบครบวงจร<br>\nเราจะสนับสนุนการซื้อขายอสังหาริมทรัพย์เพื่อการลงทุนใน โตเกียว โยโกฮาม่า โอซาก้า เคียวโต และทุกจังหวัดในญี่ปุ่น\n",
          "loan_guide": "คูมอสินเชือ",
          "newest_listings_for_rent": "ล่าสุดทรัพย์สินสำหรับให้เช่า",
          "newest_listings_for_sale": "ล่าสุดทรัพย์สินสำหรับขาย",
          "renting_guide": "คูมอการเช่า",
          "view_more_properties": "ดูโครงการทั้งหมด"
        }
      }
    }
  },
  "zh-CN": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "您的留言",
          "from_address": "你的email",
          "to_address": "收件者的email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "仲介的所在位置",
          "services": "专业领域",
          "supported_languages": "服务语言"
        },
        "enquiry": {
          "body": "欢迎给我们留言",
          "body_default": {
            "rent": "您好,\n\n我希望进一步了解物件相关资讯，请尽快与我联系。\n",
            "sale": "您好,\n\n我希望进一步了解物件相关资讯，请尽快与我联系。\n"
          },
          "country_of_residence": "您的居住国在哪里？",
          "email": "Email",
          "name": "姓名",
          "phone": "手机号码",
          "prefecture": "你在哪里寻找房产？",
          "verification_code": "验证码"
        },
        "property": {
          "beds": "格局",
          "price": "价格",
          "property_location": "房产位置",
          "property_type": "房地产种类"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "北海道",
            "10": "群马",
            "11": "埼玉",
            "12": "千叶",
            "13": "东京",
            "14": "横滨/神奈川",
            "15": "新舄",
            "16": "富山",
            "17": "金沢/石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "长野",
            "21": "岐阜",
            "22": "静冈",
            "23": "名古屋/爱知",
            "24": "三重",
            "25": "滋贺",
            "26": "京都",
            "27": "大阪",
            "28": "神戸/兵库",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鸟取",
            "32": "岛根",
            "33": "冈山",
            "34": "广岛",
            "35": "山口",
            "36": "徳岛",
            "37": "香川",
            "38": "爱媛",
            "39": "高知",
            "4": "仙台/宫城",
            "40": "福冈",
            "41": "佐贺",
            "42": "长崎",
            "43": "熊本",
            "44": "大分",
            "45": "宫崎",
            "46": "鹿児岛",
            "47": "冲绳",
            "5": "秋田",
            "6": "山形",
            "7": "福岛",
            "8": "茨城",
            "9": "栃木",
            "99": "全日本"
          },
          "prefectures": {
            "-1": "全日本",
            "1": "北海道",
            "10": "群马",
            "11": "埼玉",
            "12": "千叶",
            "13": "东京",
            "14": "神奈川",
            "15": "新舄",
            "16": "富山",
            "17": "石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "长野",
            "21": "岐阜",
            "22": "静冈",
            "23": "爱知",
            "24": "三重",
            "25": "滋贺",
            "26": "京都",
            "27": "大阪",
            "28": "兵库",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鸟取",
            "32": "岛根",
            "33": "冈山",
            "34": "广岛",
            "35": "山口",
            "36": "徳岛",
            "37": "香川",
            "38": "爱媛",
            "39": "高知",
            "4": "宫城",
            "40": "福冈",
            "41": "佐贺",
            "42": "长崎",
            "43": "熊本",
            "44": "大分",
            "45": "宫崎",
            "46": "鹿児岛",
            "47": "冲绳",
            "5": "秋田",
            "6": "山形",
            "7": "福岛",
            "8": "茨城",
            "9": "栃木"
          },
          "services": {
            "1": "出售",
            "16": "司法文书",
            "2": "出租",
            "4": "物业管理",
            "8": "装修"
          }
        },
        "property": {
          "available_from": {
            "1": "随时",
            "2": "询问",
            "3": "指定日期"
          },
          "available_from_period": {
            "1": "上旬",
            "2": "中旬",
            "3": "下旬"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "单间",
            "1": "1室",
            "101": "私人房间",
            "102": "合住房间",
            "2": "2室",
            "201": "整栋透天大楼",
            "3": "3室",
            "4": "4室",
            "5": "5室",
            "6": "6室以上"
          },
          "city_planning": {
            "1": "城市化推广区域",
            "2": "城市化控制区域",
            "3": "城市规划区域的非分类区域",
            "4": "非城市规划区"
          },
          "connecting_road_direction1": {
            "1": "北",
            "2": "东北",
            "3": "东",
            "4": "东南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction2": {
            "1": "北",
            "2": "东北",
            "3": "东",
            "4": "东南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction3": {
            "1": "北",
            "2": "东北",
            "3": "东",
            "4": "东南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction4": {
            "1": "北",
            "2": "东北",
            "3": "东",
            "4": "东南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_kind1": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind2": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind3": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind4": {
            "1": "公路",
            "2": "私家路"
          },
          "construction_status": {
            "2": "正在建设中",
            "3": "新建筑"
          },
          "guarantee_company": {
            "1": "必须利用",
            "2": "不需要",
            "3": "可得到"
          },
          "insurance": {
            "1": "需要",
            "2": "不需要"
          },
          "land_category": {
            "1": "住宅用地",
            "2": "稻田",
            "3": "农田",
            "4": "山林",
            "5": "混合地",
            "6": "其他"
          },
          "land_law_notification": {
            "1": "需要",
            "2": "不需要",
            "3": "呈报手续中"
          },
          "land_rights": {
            "1": "所有权",
            "2": "租赁权益",
            "3": "租赁权益",
            "4": "租赁权益",
            "5": "租赁权益"
          },
          "land_use_zone": {
            "1": "第一种低层居住专用地区",
            "10": "准工业地区",
            "11": "工业地区",
            "12": "工业专用地区",
            "13": "未指定",
            "14": "田园居住区",
            "2": "第二种低层居住专用地区",
            "3": "第一种中高层居住专用地区",
            "4": "第二种中高层居住专用地区",
            "5": "第一种居住地区",
            "6": "第二种居住地区",
            "7": "准居住地区",
            "8": "临近商业地区",
            "9": "商业地区"
          },
          "location": {
            "1": "北海道",
            "10": "群马",
            "11": "埼玉",
            "12": "千叶",
            "13": "东京",
            "14": "横滨/神奈川",
            "15": "新舄",
            "16": "富山",
            "17": "金沢/石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "长野",
            "21": "岐阜",
            "22": "静冈",
            "23": "名古屋/爱知",
            "24": "三重",
            "25": "滋贺",
            "26": "京都",
            "27": "大阪",
            "28": "神戸/兵库",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鸟取",
            "32": "岛根",
            "33": "冈山",
            "34": "广岛",
            "35": "山口",
            "36": "徳岛",
            "37": "香川",
            "38": "爱媛",
            "39": "高知",
            "4": "仙台/宫城",
            "40": "福冈",
            "41": "佐贺",
            "42": "长崎",
            "43": "熊本",
            "44": "大分",
            "45": "宫崎",
            "46": "鹿児岛",
            "47": "冲绳",
            "5": "秋田",
            "6": "山形",
            "7": "福岛",
            "8": "茨城",
            "9": "栃木",
            "99": "全日本"
          },
          "main_aspect": {
            "1": "北",
            "2": "东北",
            "3": "东",
            "4": "东南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "management": {
            "1": "自主管理",
            "2": "部分委托管理",
            "3": "全部委托管理"
          },
          "management_method": {
            "1": "常驻",
            "2": "日班",
            "3": "巡逻",
            "4": "无",
            "5": "兼职"
          },
          "parking_space_type": {
            "1": "可用",
            "2": "没有空缺",
            "3": "无"
          },
          "prefecture": {
            "-1": "全日本",
            "1": "北海道",
            "10": "群马",
            "11": "埼玉",
            "12": "千叶",
            "13": "东京",
            "14": "神奈川",
            "15": "新舄",
            "16": "富山",
            "17": "石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "长野",
            "21": "岐阜",
            "22": "静冈",
            "23": "爱知",
            "24": "三重",
            "25": "滋贺",
            "26": "京都",
            "27": "大阪",
            "28": "兵库",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鸟取",
            "32": "岛根",
            "33": "冈山",
            "34": "广岛",
            "35": "山口",
            "36": "徳岛",
            "37": "香川",
            "38": "爱媛",
            "39": "高知",
            "4": "宫城",
            "40": "福冈",
            "41": "佐贺",
            "42": "长崎",
            "43": "熊本",
            "44": "大分",
            "45": "宫崎",
            "46": "鹿児岛",
            "47": "冲绳",
            "5": "秋田",
            "6": "山形",
            "7": "福岛",
            "8": "茨城",
            "9": "栃木"
          },
          "property_type": {
            "-1": "全部",
            "1": "公寓",
            "10": "整栋商业楼",
            "11": "整栋酒店及旅馆",
            "12": "联排别墅",
            "2": "独栋住宅",
            "3": "土地",
            "4": "短期租约",
            "5": "合租公寓",
            "6": "整栋公寓大楼",
            "7": "办公室",
            "8": "零售商铺",
            "9": "办公室及零售商铺"
          },
          "purpose": {
            "1": "For Residence",
            "2": "投資"
          },
          "status": {
            "1": "空置",
            "10": "使用中",
            "2": "居住中",
            "3": "建设中",
            "4": "空地",
            "5": "有旧房",
            "6": "带租约",
            "7": "部分出租",
            "8": "全部出租",
            "9": "从未入住"
          },
          "structure": {
            "1": "木造结构",
            "10": "ALC",
            "11": "RCB",
            "12": "CFT",
            "13": "木造结构・其他",
            "14": "钢筋混凝土・其他",
            "15": "钢筋混凝土・其他",
            "16": "钢架・其他",
            "17": "Block・其他",
            "18": "PC・其他",
            "19": "HPC・其他",
            "2": "钢筋混凝土",
            "20": "LGS・其他",
            "21": "ALC・其他",
            "22": "RCB・其他",
            "23": "CFT・其他",
            "3": "钢筋混凝土",
            "4": "钢架",
            "5": "Block",
            "6": "PC",
            "7": "HPC",
            "8": "Other",
            "9": "LGS"
          },
          "type": {
            "rent": "租赁",
            "sale": "购买"
          },
          "type_of_transaction": {
            "1": "业主",
            "2": "直销",
            "3": "专属专任中介合同",
            "4": "专任中介合同",
            "5": "一般中介合同",
            "6": "中介",
            "7": "其他"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "抱歉，我们找不到符合您搜寻条件的业者。<br>请用不同的条件尝试搜索"
        }
      }
    },
    "c": {
      "bookmarked_properties": "添加入收藏的房产",
      "buy": "买房",
      "city_ward": "市区町村",
      "featured": "特色房地产",
      "for_rent": "出租",
      "for_sale": "出售",
      "japan_blog": "日本博客",
      "login": "登录",
      "logout": "登出",
      "make_enquiry": "立刻询问",
      "max_price": "最高价格（日元）",
      "name": "名字",
      "no_max_price": "无最高价格",
      "no_max_price_short": "无最高价格",
      "no_min_price_short": "无最低价格",
      "phone": "手机号码",
      "please_write_your_message": "欢迎给我们留言*",
      "price_rent": {
        "from": "价格",
        "to": "租金"
      },
      "property_agencies_and_sellers": "%{location}房产中介",
      "provided_by": "房屋资讯来源",
      "read_more": "查看更多",
      "rent": "租房",
      "sale": "买房",
      "search": "搜索",
      "search_box": {
        "home_type": "Home Type",
        "maximum": "Maximum",
        "minimum": "Minimum",
        "price_range": "Price Range"
      },
      "search_by": {
        "fewer_filters": "更少",
        "more_filters": "其他搜索",
        "prefecture": "都道府县",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "物业类型",
        "search_by_city": "从地区搜索",
        "search_by_train_station": "从路线搜索",
        "search_for_homes_by_city": "从地区搜索房屋"
      },
      "search_for_properties": "房地产搜索",
      "sign_up": "注册",
      "type_of_home": "物业类型",
      "yen": "日元"
    },
    "devise": {
      "registrations": {
        "confirm_destroy": {
          "js": {
            "confirmation": "您确定要永久删除帐号吗？"
          }
        }
      }
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "点击联系置业顾问即表示您同意 Japan-Property 和房地产专业人员可以通过电话/短信与您联系，这可能涉及使用自动化手段。您不需要同意购买任何房地产或服务的条件。信息/数据费用可能适用。您还同意遵守我们的<a href='/zh-CN/terms'>使用条款</a>，并同意我们的<a href='/zh-CN/privacy-policy'>隐私政策</a>，有关您的信息。我们可能会与您的代理商分享有关您最近和未来网站活动的信息，以帮助他们了解您在寻找什么样的住宅。",
          "contact_agent": "联系置业顾问",
          "submit": "联系置业顾问"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "请选择市区郡",
          "select_prefecture": "请选择房产位置",
          "title": "从地区搜索房地产"
        }
      },
      "index": {
        "js": {
          "cities": "城市",
          "empty": "抱歉，我们无法找到与您搜索条件匹配的房产。<br>请更改条件重新搜索房产。",
          "features": "特色",
          "luxury": "豪华出租",
          "over_selected": "您可以同时查询最多5个物业。请完成您的查询。",
          "relevant_listings": "默认",
          "sort": "排序: ",
          "sort_by_gross_yield_higher": "最高租金收益率",
          "sort_by_home_age_higher": "房龄新到旧",
          "sort_by_home_size_higher": "面积大到小",
          "sort_by_land_size_higher": "土地面积大到小",
          "sort_by_price_higher": "降序价格",
          "sort_by_price_lower": "升序价格",
          "sort_by_purpose": "投資"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "检查一下我在Japan-Property找到的这个房子。",
            "send_email": "提交email",
            "sent": "成功分享此物业"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "请选择车站",
          "please_select_train_lines": "请选择路线",
          "select_prefecture": "请选择房产位置",
          "select_stations": "选择站",
          "title": "从路线搜索房地产"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "删除帐户",
          "favorite": "添加入收藏的房产",
          "myaccount": "我的帐号"
        },
        "language": "语言切换"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "区域指南",
          "buying_guide": "购房指南",
          "catch_copy": "搜索可在日本购买或租赁的最佳房产",
          "explore_top_neighborhoods": "热门地区",
          "featured_agencies_and_sellers": "特色房屋仲介和业主",
          "featured_properties_for_rent": "推荐出租房源",
          "featured_properties_for_sale": "推荐出售房源",
          "find_more_agents": "寻找更多房屋仲介",
          "footer_description": "Japan-property.jp 是日本数一数二的房地产网站。国外的买家和投资人可以透过日本顶尖的房屋仲介和房地产开发商寻找房产。 网站的搜寻工具能够让客户轻松购买，销售或租赁房地产。<br>支援东京，横滨，大阪，京都等日本全国各地的投资用房地产购买和公寓，房子之类的出租",
          "loan_guide": "贷款指南",
          "newest_listings_for_rent": "最新出租房源",
          "newest_listings_for_sale": "最新出售房源",
          "renting_guide": "租房指南",
          "view_more_properties": "查看更多房产"
        }
      }
    }
  },
  "zh-TW": {
    "activemodel": {
      "attributes": {
        "share_content": {
          "body": "您的留言",
          "from_address": "你的email",
          "to_address": "收件者的email"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "agent_profile": {
          "agent_location": "仲介的所在位置",
          "services": "專業項目",
          "supported_languages": "服務語言"
        },
        "enquiry": {
          "body": "歡迎給我們留言",
          "body_default": {
            "rent": "您好,\n\n我希望進一步了解物件相關資訊，請盡快與我聯繫。\n",
            "sale": "您好,\n\n我希望進一步了解物件相關資訊，請盡快與我聯繫。\n"
          },
          "country_of_residence": "您的居住國在哪裡？",
          "email": "Email",
          "name": "姓名",
          "phone": "手機號碼",
          "prefecture": "你在哪裡尋找房產？",
          "verification_code": "驗證碼"
        },
        "property": {
          "beds": "格局",
          "price": "價格",
          "property_location": "房產位置",
          "property_type": "房地產種類"
        }
      },
      "enums": {
        "agent_profile": {
          "locations": {
            "1": "北海道",
            "10": "群馬",
            "11": "埼玉",
            "12": "千葉",
            "13": "東京",
            "14": "橫濱/神奈川",
            "15": "新潟",
            "16": "富山",
            "17": "金沢/石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "長野",
            "21": "岐阜",
            "22": "静岡",
            "23": "名古屋/愛知",
            "24": "三重",
            "25": "滋賀",
            "26": "京都",
            "27": "大阪",
            "28": "神戸/兵庫",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鳥取",
            "32": "島根",
            "33": "岡山",
            "34": "廣島",
            "35": "山口",
            "36": "徳島",
            "37": "香川",
            "38": "愛媛",
            "39": "高知",
            "4": "仙台/宮城",
            "40": "福岡",
            "41": "佐賀",
            "42": "長崎",
            "43": "熊本",
            "44": "大分",
            "45": "宮崎",
            "46": "鹿児島",
            "47": "沖繩",
            "5": "秋田",
            "6": "山形",
            "7": "福島",
            "8": "茨城",
            "9": "栃木",
            "99": "全日本"
          },
          "prefectures": {
            "-1": "全日本",
            "1": "北海道",
            "10": "群馬",
            "11": "埼玉",
            "12": "千葉",
            "13": "東京",
            "14": "神奈川",
            "15": "新潟",
            "16": "富山",
            "17": "石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "長野",
            "21": "岐阜",
            "22": "静岡",
            "23": "愛知",
            "24": "三重",
            "25": "滋賀",
            "26": "京都",
            "27": "大阪",
            "28": "兵庫",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鳥取",
            "32": "島根",
            "33": "岡山",
            "34": "廣島",
            "35": "山口",
            "36": "徳島",
            "37": "香川",
            "38": "愛媛",
            "39": "高知",
            "4": "宮城",
            "40": "福岡",
            "41": "佐賀",
            "42": "長崎",
            "43": "熊本",
            "44": "大分",
            "45": "宮崎",
            "46": "鹿児島",
            "47": "沖繩",
            "5": "秋田",
            "6": "山形",
            "7": "福島",
            "8": "茨城",
            "9": "栃木"
          },
          "services": {
            "1": "出售",
            "16": "司法代書人",
            "2": "出租",
            "4": "物業管理",
            "8": "裝修"
          }
        },
        "property": {
          "available_from": {
            "1": "立即",
            "2": "商談",
            "3": "指定日期"
          },
          "available_from_period": {
            "1": "上旬",
            "2": "中旬",
            "3": "下旬"
          },
          "bathrooms": {
            "0.0": 0,
            "0.5": 0.5,
            "1.0": 1,
            "1.5": 1.5,
            "2.0": 2,
            "2.5": 2.5,
            "3.0": 3,
            "3.5": 3.5,
            "4.0": "4+"
          },
          "bedrooms": {
            "-1": "套房",
            "1": "1房",
            "101": "私人房間",
            "102": "合住房間",
            "2": "2房",
            "201": "整棟透天大樓",
            "3": "3房",
            "4": "4房",
            "5": "5房",
            "6": "6房以上"
          },
          "city_planning": {
            "1": "城市化推廣區域",
            "2": "城市化調整區域",
            "3": "城市規劃區域的非分類區域",
            "4": "非都市計畫區域"
          },
          "connecting_road_direction1": {
            "1": "北",
            "2": "東北",
            "3": "東",
            "4": "東南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction2": {
            "1": "北",
            "2": "東北",
            "3": "東",
            "4": "東南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction3": {
            "1": "北",
            "2": "東北",
            "3": "東",
            "4": "東南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_direction4": {
            "1": "北",
            "2": "東北",
            "3": "東",
            "4": "東南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "connecting_road_kind1": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind2": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind3": {
            "1": "公路",
            "2": "私家路"
          },
          "connecting_road_kind4": {
            "1": "公路",
            "2": "私家路"
          },
          "construction_status": {
            "2": "正在建設中",
            "3": "新建築"
          },
          "guarantee_company": {
            "1": "使用時必需",
            "2": "不需要",
            "3": "可以使用"
          },
          "insurance": {
            "1": "需要",
            "2": "不需要"
          },
          "land_category": {
            "1": "住宅用地",
            "2": "稻田",
            "3": "農田",
            "4": "山林",
            "5": "混合地",
            "6": "其他"
          },
          "land_law_notification": {
            "1": "需要",
            "2": "不需要",
            "3": "申報手續中"
          },
          "land_rights": {
            "1": "所有權",
            "2": "租賃產權",
            "3": "租賃產權",
            "4": "租賃產權",
            "5": "租賃產權"
          },
          "land_use_zone": {
            "1": "第一種低層居住專用地區",
            "10": "準工業地區",
            "11": "工業地區",
            "12": "工業專用地區",
            "13": "未指定",
            "14": "田園居住區",
            "2": "第二種低層居住專用地區",
            "3": "第一種中高層居住專用地區",
            "4": "第二種中高層居住專用地區",
            "5": "第一種居住地區",
            "6": "第二種居住地區",
            "7": "準居住地區",
            "8": "臨近商業地區",
            "9": "商業地區"
          },
          "location": {
            "1": "北海道",
            "10": "群馬",
            "11": "埼玉",
            "12": "千葉",
            "13": "東京",
            "14": "橫濱/神奈川",
            "15": "新潟",
            "16": "富山",
            "17": "金沢/石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "長野",
            "21": "岐阜",
            "22": "静岡",
            "23": "名古屋/愛知",
            "24": "三重",
            "25": "滋賀",
            "26": "京都",
            "27": "大阪",
            "28": "神戸/兵庫",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鳥取",
            "32": "島根",
            "33": "岡山",
            "34": "廣島",
            "35": "山口",
            "36": "徳島",
            "37": "香川",
            "38": "愛媛",
            "39": "高知",
            "4": "仙台/宮城",
            "40": "福岡",
            "41": "佐賀",
            "42": "長崎",
            "43": "熊本",
            "44": "大分",
            "45": "宮崎",
            "46": "鹿児島",
            "47": "沖繩",
            "5": "秋田",
            "6": "山形",
            "7": "福島",
            "8": "茨城",
            "9": "栃木",
            "99": "全日本"
          },
          "main_aspect": {
            "1": "北",
            "2": "東北",
            "3": "東",
            "4": "東南",
            "5": "南",
            "6": "西南",
            "7": "西",
            "8": "西北"
          },
          "management": {
            "1": "自主管理",
            "2": "部分委託管理",
            "3": "全部委託管理"
          },
          "management_method": {
            "1": "常駐",
            "2": "日班",
            "3": "巡邏",
            "4": "無",
            "5": "非常駐"
          },
          "parking_space_type": {
            "1": "有空位",
            "2": "沒有空位",
            "3": "無"
          },
          "prefecture": {
            "-1": "全日本",
            "1": "北海道",
            "10": "群馬",
            "11": "埼玉",
            "12": "千葉",
            "13": "東京",
            "14": "神奈川",
            "15": "新潟",
            "16": "富山",
            "17": "石川",
            "18": "福井",
            "19": "山梨",
            "2": "青森",
            "20": "長野",
            "21": "岐阜",
            "22": "静岡",
            "23": "愛知",
            "24": "三重",
            "25": "滋賀",
            "26": "京都",
            "27": "大阪",
            "28": "兵庫",
            "29": "奈良",
            "3": "岩手",
            "30": "和歌山",
            "31": "鳥取",
            "32": "島根",
            "33": "岡山",
            "34": "廣島",
            "35": "山口",
            "36": "徳島",
            "37": "香川",
            "38": "愛媛",
            "39": "高知",
            "4": "宮城",
            "40": "福岡",
            "41": "佐賀",
            "42": "長崎",
            "43": "熊本",
            "44": "大分",
            "45": "宮崎",
            "46": "鹿児島",
            "47": "沖繩",
            "5": "秋田",
            "6": "山形",
            "7": "福島",
            "8": "茨城",
            "9": "栃木"
          },
          "property_type": {
            "-1": "全部",
            "1": "公寓",
            "10": "整棟商業大樓",
            "11": "整棟飯店及旅館",
            "12": "聯排別墅",
            "2": "獨棟住宅",
            "3": "土地",
            "4": "短期租約",
            "5": "合租公寓",
            "6": "整棟公寓大樓",
            "7": "辦公室",
            "8": "零售商舖",
            "9": "辦公室及零售商舖"
          },
          "purpose": {
            "1": "For Residence",
            "2": "投資"
          },
          "status": {
            "1": "空置",
            "10": "使用中",
            "2": "居住中",
            "3": "建設中",
            "4": "空地",
            "5": "有舊房",
            "6": "帶租約",
            "7": "部分出租",
            "8": "全部出租",
            "9": "從未入住"
          },
          "structure": {
            "1": "木造結構",
            "10": "ALC",
            "11": "RCB",
            "12": "CFT",
            "13": "木造結構・其他",
            "14": "鋼筋混凝土・其他",
            "15": "鋼筋混凝土・其他",
            "16": "钢架・其他",
            "17": "Block・其他",
            "18": "PC・其他",
            "19": "HPC・其他",
            "2": "鋼筋混凝土",
            "20": "LGS・其他",
            "21": "ALC・其他",
            "22": "RCB・其他",
            "23": "CFT・其他",
            "3": "鋼筋混凝土",
            "4": "钢架",
            "5": "Block",
            "6": "PC",
            "7": "HPC",
            "8": "Other",
            "9": "LGS"
          },
          "type": {
            "rent": "租賃",
            "sale": "購買"
          },
          "type_of_transaction": {
            "1": "業主",
            "2": "代理",
            "3": "專屬專任委託",
            "4": "專任委託",
            "5": "一般委託",
            "6": "仲介",
            "7": "其他"
          }
        }
      }
    },
    "agencies": {
      "index": {
        "js": {
          "empty": "抱歉，我們找不到符合您搜尋條件的業者。<br>請用不同的條件嘗試搜索。"
        }
      }
    },
    "c": {
      "bookmarked_properties": "添加入收藏的房產",
      "buy": "買屋",
      "city_ward": "市區町村",
      "featured": "房地產特色",
      "for_rent": "出租",
      "for_sale": "出售",
      "japan_blog": "日本部落格",
      "login": "登入",
      "logout": "登出",
      "make_enquiry": "查詢",
      "max_price": "最高價格（日幣）",
      "name": "名字",
      "no_max_price": "無最高價格",
      "no_max_price_short": "無最高價格",
      "no_min_price_short": "無最低價格",
      "phone": "手機號碼",
      "please_write_your_message": "歡迎給我們留言*",
      "price_rent": {
        "from": "價格",
        "to": "租金"
      },
      "property_agencies_and_sellers": "%{location}房屋仲介",
      "provided_by": "房屋資訊來源",
      "read_more": "查看更多",
      "rent": "租屋",
      "sale": "買屋",
      "search": "搜尋",
      "search_box": {
        "home_type": "Home Type",
        "maximum": "Maximum",
        "minimum": "Minimum",
        "price_range": "Price Range"
      },
      "search_by": {
        "fewer_filters": "更少",
        "more_filters": "其他搜尋",
        "prefecture": "都道府縣",
        "properties_count_surfix": "%{content} (%{count})",
        "property_type": "物件類型",
        "search_by_city": "從地區搜尋",
        "search_by_train_station": "從路線搜尋",
        "search_for_homes_by_city": "從地區搜尋房屋"
      },
      "search_for_properties": "房地產搜索",
      "sign_up": "註冊",
      "type_of_home": "物件類型",
      "yen": "日幣"
    },
    "devise": {
      "registrations": {
        "confirm_destroy": {
          "js": {
            "confirmation": "您確定要永久刪除帳號嗎？"
          }
        }
      }
    },
    "enquiries": {
      "show": {
        "js": {
          "caution": "點擊聯繫置業顧問即表示您同意 Japan-Property 和房地產專業人員可以透過電話/簡訊與您聯繫，這可能涉及使用自動化手段。您不需要同意購買任何房地產或服務的條件。信息/數據費用可能適用。您還同意遵守我們的<a href='/zh-TW/terms'>使用條款</a>，並同意我們的<a href='/zh-TW/privacy-policy'>隱私政策</a>，涉及與您相關的信息。我們可能會與您的代理商分享有關您最近和未來網站活動的信息，以幫助他們了解您在尋找什麼樣的住宅。",
          "contact_agent": "聯繫置業顧問",
          "submit": "联系置业顾问"
        }
      }
    },
    "properties": {
      "city": {
        "js": {
          "please_select_cities": "請選擇市區郡",
          "select_prefecture": "請選擇房產位置",
          "title": "從地區搜尋房地產"
        }
      },
      "index": {
        "js": {
          "cities": "城市",
          "empty": "抱歉，我們無法找到任何符合您搜尋條件的房產。<br>請嘗試用其他條件來搜尋。",
          "features": "特色",
          "over_selected": "您可以同時查詢最多5個物業。請完成您的查詢。",
          "relevant_listings": "預設",
          "sort": "排序: ",
          "sort_by_gross_yield_higher": "最高租金收益率",
          "sort_by_home_age_higher": "房齡新到舊",
          "sort_by_home_size_higher": "面積大到小",
          "sort_by_land_size_higher": "土地面積大到小",
          "sort_by_price_higher": "降序價格",
          "sort_by_price_lower": "升序價格",
          "sort_by_purpose": "投資"
        }
      },
      "show": {
        "js": {
          "share": {
            "placeholder_message": "檢查一下我在Japan-Property找到的這個房子。",
            "send_email": "提交email",
            "sent": "成功分享此物業"
          }
        }
      },
      "train": {
        "js": {
          "please_select_stations": "請選擇車站",
          "please_select_train_lines": "請選擇路線",
          "select_prefecture": "請選擇房產位置",
          "select_stations": "選擇車站",
          "title": "從路線搜尋房地產"
        }
      }
    },
    "shared": {
      "header": {
        "js": {
          "delete_account": "刪除帳戶",
          "favorite": "添加入收藏的房產",
          "myaccount": "我的帳號"
        },
        "language": "語言切換"
      }
    },
    "welcome": {
      "index": {
        "js": {
          "area_guides": "區域指南",
          "buying_guide": "購屋指南",
          "catch_copy": "尋找您在日本最適合購買或租賃的房產",
          "explore_top_neighborhoods": "熱門區域",
          "featured_agencies_and_sellers": "特色房屋仲介和賣家",
          "featured_properties_for_rent": "推薦出租房源",
          "featured_properties_for_sale": "推薦出售房源",
          "find_more_agents": "尋找更多房屋仲介",
          "footer_description": "Japan-property.jp 是日本數一數二的房地產網站。國外的買家和投資人可以透過日本頂尖的房屋仲介和房地產開發商尋找房產。 網站的搜尋工具能夠讓客戶輕鬆購買，銷售或租賃房地產。<br>支援東京、横濱、大阪、京都等日本全國各地的投資用不動産購買和公寓，房子之類的出租",
          "loan_guide": "貸款指南",
          "newest_listings_for_rent": "最新出租房源",
          "newest_listings_for_sale": "最新出售房源",
          "renting_guide": "租屋指南",
          "view_more_properties": "查看更多房產"
        }
      }
    }
  }
}